webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7eeda317",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b25ae418",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-572f72a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(184);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement /*, fromIndex*/) {
    'use strict';

    var O = Object(this);
    var len = parseInt(O.length) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1]) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
        return true;
      }
      k++;
    }
    return false;
  };
}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// Conclusión
(function () {
  /**
   * Ajuste decimal de un número.
   *
   * @param {String}  tipo  El tipo de ajuste.
   * @param {Number}  valor El numero.
   * @param {Integer} exp   El exponente (el logaritmo 10 del ajuste base).
   * @returns {Number} El valor ajustado.
   */
  function decimalAdjust(type, value, exp) {
    // Si el exp no está definido o es cero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Si el valor no es un número o el exp no es un entero...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function (value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function (value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function (value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }
})();

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Functionals_Newsfeed__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Functionals_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Functionals_Newsfeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Shared_Report___ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Shared_Report____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Shared_Report___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Functionals_Audit__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Functionals_Audit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Functionals_Audit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Profile___ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Profile____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Shared_Profile___);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Newsfeed',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Functionals_Newsfeed___default.a
  }, {
    path: '/index.html',
    redirect: '/'
  }, {
    path: '/mis-reportes',
    name: 'Mis Reportes',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Shared_Report____default.a
  }, {
    path: '/auditoria',
    name: 'Auditoría',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Functionals_Audit___default.a
  }, {
    path: '/mi-perfil',
    name: 'Mi Perfil',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Shared_Profile____default.a
  }],
  mode: 'history'
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$title.hasOwnProperty('show') ? __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$title.show(to.name) : false;
  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Dialog___ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Dialog____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Shared_Dialog___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Shared_Home___ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Shared_Home____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Shared_Home___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Shared_Loading___ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Shared_Loading____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Shared_Loading___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Shared_Login___ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Shared_Login____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Shared_Login___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Shared_Snackbar___ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Shared_Snackbar____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Shared_Snackbar___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Toast___ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Toast____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Shared_Toast___);
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentView: __WEBPACK_IMPORTED_MODULE_3__components_Shared_Login____default.a,
      showLoading: false,
      snackbar: {}
    };
  },
  methods: {
    checkSession: function checkSession() {
      // setTimeout( () => {
      //   axios.get(this.api + 'login/?user=')
      //     .then( response => {
      //       console.log(response)
      //     }).catch( error => {

      //     })
      // }, 1000)
    },
    reloadToken: function reloadToken() {
      var self = this;

      /*gapi.load('auth2', function() {
        gapi.auth2.init().then(googleAuth => {
          const googleUser = googleAuth.currentUser.get(),
                authResponse = googleUser.getAuthResponse(),
                idToken = authResponse.id_token
                // isNewToken = self.$user.data.idToken !== idToken
            // if (isNewToken) {
            self.$user.data.idToken = idToken
            self.$http.defaults.headers.common['Authorization'] = idToken
            return self.$idb.keyVal.set('login', undefined, self.$user.data)
          // }
        })
      })*/
    }
  },
  mounted: function mounted() {
    var self = this,
        toast = this.$toast;

    this.$http.interceptors.response.use(function (response) {
      var status = response.data.status ? response.data.status : false;
      if (status && status.match(/no\sautorizado/)) {
        // self.reloadToken()
        return toast.show('Por favor, intenta de nuevo realizar la consulta.');
      }

      if (response.data.success === '0') {
        return toast.show(response.data.response);
      }

      return response;
    }, function (error) {
      var errorData = error.response ? error.response.data : false;
      if (errorData && errorData.status.match(/no\sautorizado/)) {

        // self.reloadToken()
        return toast.show('Por favor, intenta de nuevo realizar la consulta.');
      }
    });
  },

  components: {
    Login: __WEBPACK_IMPORTED_MODULE_3__components_Shared_Login____default.a,
    Home: __WEBPACK_IMPORTED_MODULE_1__components_Shared_Home____default.a,
    'app-dialog': __WEBPACK_IMPORTED_MODULE_0__components_Shared_Dialog____default.a,
    'app-loading': __WEBPACK_IMPORTED_MODULE_2__components_Shared_Loading____default.a,
    'app-snackbar': __WEBPACK_IMPORTED_MODULE_4__components_Shared_Snackbar____default.a,
    'app-toast': __WEBPACK_IMPORTED_MODULE_5__components_Shared_Toast____default.a
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Audit__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Audit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Audit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed__);






/* harmony default export */ __webpack_exports__["default"] = ({
  functional: true,
  render: function render(createElement, context) {
    var user = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$user.data;
    var element = null;

    switch (user.roleCode) {
      case 'auditor':
        element = __WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Audit___default.a;
        break;

      case 'jefe':
        element = __WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed___default.a;
        break;

      case 'mantenimiento':
        element = __WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed___default.a;
        break;

      default:
        // statements_def
        break;
    }

    return createElement(element);
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Newsfeed__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Newsfeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed__);






/* harmony default export */ __webpack_exports__["default"] = ({
  functional: true,
  render: function render(createElement, context) {
    var user = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$user.data;
    var element = null;

    switch (user.roleCode) {
      case 'auditor':
        element = __WEBPACK_IMPORTED_MODULE_1__components_Roles_Auditor_Newsfeed___default.a;
        break;

      case 'jefe':
        element = __WEBPACK_IMPORTED_MODULE_2__components_Roles_Jefe_Newsfeed___default.a;
        break;

      case 'mantenimiento':
        element = __WEBPACK_IMPORTED_MODULE_3__components_Roles_Mantenimiento_Newsfeed___default.a;
        break;

      default:
        // statements_def
        break;
    }

    return createElement(element);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tree', 'data', 'index'],
  data: function data() {
    return {
      currentIndex: 0
    };
  },

  methods: {
    adjustAccordions: function adjustAccordions() {
      var contents = document.querySelectorAll('.mdl-accordion__content');
      for (var i = contents.length - 1; i >= 0; i--) {
        var content = contents[i];
        content.style.marginTop = -1 * content.offsetHeight + 'px';
      }
    },
    toggleAccordion: function toggleAccordion(event) {
      event.target.parentNode.classList.toggle('mdl-accordion--opened');
    },
    openChips: function openChips(event) {
      var chipsContainer = event.target.parentNode.querySelector('.mdl-chip__buttons');
      chipsContainer.classList.add('mdl-chip__buttons--opened');
    },
    chipSelected: function chipSelected(event) {
      var chipSelected = event.target,
          chipsContainer = chipSelected.parentNode,
          currentChip = chipsContainer.parentNode.querySelector('.current-chip'),
          content = currentChip.parentNode.parentNode,
          incidence = content.querySelector('.incidence'),
          i = chipsContainer.dataset.i,
          especificacion = this.data.especificaciones[i];

      especificacion.selected.color = chipSelected.dataset.color;
      especificacion.selected.id = chipSelected.dataset.id;
      especificacion.selected.valor = 1 * chipSelected.dataset.value;
      chipsContainer.classList.remove('mdl-chip__buttons--opened');

      if (especificacion.selected.color.match(/red|yellow/)) {
        incidence.classList.add('incidence--opened');
      } else {
        incidence.classList.remove('incidence--opened');
      }

      content.style.marginTop = -1 * content.offsetHeight + 'px';
      this.$emit("trigger", Math.random());
    },
    uploadPicture: function uploadPicture(event) {
      event.currentTarget.querySelector('input[type="file"]').click();
    },
    imageToDataUri: function imageToDataUri(img, width, height, quality) {
      // create an off-screen canvas
      var canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');

      // set its dimension to target size
      canvas.width = width;
      canvas.height = height;

      // draw source image into the off-screen canvas:
      ctx.drawImage(img, 0, 0, width, height);

      // encode image to data-uri with base64 version of compressed image
      return canvas.toDataURL('image/jpeg', quality);
    },
    showPicture: function showPicture(event) {
      // spinner.classList.remove('hidden');
      // selectPicture.disabled = true;
      // Get a reference to the taken picture or chosen file
      var self = this;
      var fileInput = event.target,
          files = fileInput.files,
          file = void 0,
          fileSize = void 0,
          fileReader = new FileReader(),
          i = fileInput.dataset.i,
          especificacion = this.data.especificaciones[i];

      // especificacion.images = especificacion.images ? especificacion.images : []
      if (especificacion.imagenes.length >= 3) {
        return;
      }

      if (files && files.length > 0) {
        file = files[0];
        fileSize = file.size;

        fileReader.onload = function (event) {
          var img = new Image();
          // let anchor = document.createElement('a')
          var newDataUri = void 0;
          var snackbar = {
            message: '¿Deseas descargar la imágen?',
            actionHandler: false,
            actionText: 'Descargar'
          };

          img.onload = function (i) {
            newDataUri = fileSize > 3000000 ? self.imageToDataUri(img, img.width * 0.25, img.height * 0.25, 0.3) : newDataUri = self.imageToDataUri(img, img.width * 0.5, img.height * 0.5, 0.4);

            // showPicture.src = newDataUri;
            // showPicture.classList.remove('hidden');
            // selectPicture.disabled = false;
            especificacion.imagenes.push(newDataUri);

            setTimeout(function () {
              self.adjustAccordions();
            }, 1000);
            // self.$idb.keyVal.set(undefined, self.data)
            // console.log(especificacion.images)
          };

          img.src = fileReader.result;
          // anchor.textContent = 'Descargar'
          // anchor.href = fileReader.result
          // anchor.download = self.tree.inmueble.nombre + '__' +
          //   self.tree.area.nombre + '__' +
          //   self.data.nombre + '__' +
          //   especificacion.nombre + '__' +
          //   (especificacion.imagenes.length + 1)
          // snackbar.actionHandler = () => { anchor.click() }
          // self.$snackbar.init(snackbar)
          // spinner.classList.add('hidden');
        };
        fileReader.readAsDataURL(file);
      } else {
        // Aqui la imagen se crea y luego te destruye.
        // spinner.classList.add('hidden');
        // selectPicture.disabled = false;
      }
    },
    downloadPicture: function downloadPicture(event) {
      var downloadButton = event.currentTarget,
          i = downloadButton.dataset.i,
          k = downloadButton.dataset.k,
          especificacion = this.data.especificaciones[i],
          imagenes = especificacion.imagenes,
          anchor = document.createElement('a');
      // url = imagenes[k].replace(/^data:image\/[^;]+/, 'data:application/octet-stream'),
      // win = window.open(imagenes[k], '_blank')

      anchor.href = imagenes[k];
      anchor.target = '_blank';
      anchor.download = this.tree.inmueble.nombre + '__' + this.tree.area.nombre + '__' + this.data.nombre + '__' + especificacion.nombre + '__' + (imagenes.length + 1);

      return anchor.click();

      // image.src = imagenes[k]

      // return win.document.write(image.outerHTML)
      // return window.open(imagenes[k], '_blank')
    },
    removePicture: function removePicture(event) {
      var deleteButton = event.currentTarget,
          i = deleteButton.dataset.i,
          k = deleteButton.dataset.k,
          especificacion = this.data.especificaciones[i],
          imagenes = especificacion.imagenes;

      return imagenes.splice(k, 1);
    }
  },
  mounted: function mounted() {
    this.adjustAccordions();
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'));
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'));
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Accordion__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Accordion__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tree', 'data', 'index'],
  components: {
    'mdl-accordion': __WEBPACK_IMPORTED_MODULE_1__Accordion___default.a
  },
  data: function data() {
    var _this = this;

    return {
      promedio: 0,
      actionbar: {
        show: true,
        buttons: [{
          text: 'Regresar',
          onclick: function onclick() {
            _this.$emit('goBack', -1);
          }
        }, {
          text: 'Guardar',
          onclick: function onclick() {
            var textfields = document.querySelectorAll('.incidence--opened .mdl-textfield__input'),
                photos = document.querySelectorAll('.incidence--opened .photos');

            for (var i in textfields) {
              if (textfields[i].value === '') {
                return _this.$toast.show('Favor de escribir tus observaciones en cada incidencia.');
              }
            }

            for (var _i in photos) {
              if (photos[_i].childElementCount === 0) {
                return _this.$toast.show('Favor de asignar mínimo una fotografía en cada incidencia.');
              }
            }

            var rubros = _this.data,
                promises = [];

            rubros.forEach(function (rubro) {
              rubro.puntos = 0;
              rubro.incidencias = 0;

              rubro.especificaciones.forEach(function (especificacion) {
                rubro.puntos += especificacion.selected.valor;
                rubro.incidencias += especificacion.selected.color.match(/red|yellow/) ? 1 : 0;
              });

              rubro.promedio = Math.round10(rubro.puntos / rubro.especificaciones.length, -2);
              promises.push(_this.$idb.keyVal.set('rubros', undefined, rubro));
            });

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
              _this.$emit('activeAudit', true);
              _this.$emit('goBack', -1);
            }, function () {
              _this.$toast.show('¡Algo sucedió! Porfavor vuelve a intentar guardar.');
            });
          }
        }]
      }
    };
  },

  methods: {
    calcularPromedio: function calcularPromedio() {
      var rubros = this.data;
      var puntos = 0,
          length = 0;

      rubros.forEach(function (rubro) {
        length += rubro.especificaciones.length;
        rubro.especificaciones.forEach(function (especificacion) {
          puntos += especificacion.selected.valor;
        });
      });

      this.promedio = Math.round10(puntos / length, -2);
    }
  },
  watch: {
    data: function data() {
      this.calcularPromedio();
      this.$actionbar.init(this.actionbar);
    }
  },
  mounted: function mounted() {
    this.calcularPromedio();
    this.$actionbar.init(this.actionbar);
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['i', 'data', 'index', 'clickEvent'],
  data: function data() {
    return {};
  },

  methods: {
    clicked: function clicked() {
      console.log('hi hi');
    }
  },
  mounted: function mounted() {
    this.$emit('showActionbar', false);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'index', 'changeEvent'],
  data: function data() {
    return {};
  },

  methods: {
    menuItemSelected: function menuItemSelected(event) {
      var menu = event.currentTarget,
          menuItem = event.target;

      // this.selected = menuItem.textContent
      menu.MaterialMenu.toggle();

      this.changeEvent(menuItem);
    }
  },
  mounted: function mounted() {
    // this.selected = this.item.default.name
    componentHandler.upgradeElement(this.$el.querySelector('.mdl-menu'));
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tree', 'data', 'childData', 'index', 'clickEvent'],
  data: function data() {
    var _this = this;

    return {
      readyToSend: false,
      missing: 0,
      promedio: 0,
      actionbar: {
        show: true,
        buttons: [{
          text: 'Cancelar',
          onclick: function onclick() {
            _this.$dialog.accept = function () {
              _this.borrarAuditoriaActiva();
              _this.$toast.show('Cancelaste la Auditoría');
            };

            _this.$dialog.show('Cancelar Auditoría', 'Estás a punto de cancelar la auditoría. Se borrarán todas las' + ' incidencias que guardaste, ¿deseas continuar?');
          }
        }, {
          text: 'Enviar',
          onclick: function onclick() {
            if (!_this.readyToSend) {
              return _this.$toast.show('Favor de evaluar todas las áreas (' + _this.missing + ').');
            }

            _this.$dialog.accept = function () {
              var areas = _this.data;
              var auditoria = {
                user_id: _this.$user.data.id,
                inmueble_id: _this.tree.inmueble.id,
                promedio: _this.tree.inmueble.promedio,
                resumen: _this.tree.inmueble.resumen,
                incidencias: []
              },
                  imagenes = [],
                  promises = [];

              if (auditoria.resumen.length === 0) {
                return _this.$toast.show('Favor de escribir tu RESUMEN de la auditoría.');
              }

              areas.forEach(function (area) {
                promises.push(_this.$idb.keyVal.getOnly('rubros', 'padreId', area.id).then(function (rubros) {
                  rubros.forEach(function (rubro) {
                    rubro.especificaciones.forEach(function (especificacion) {
                      auditoria.incidencias.push({
                        ponderacion_id: especificacion.selected.id,
                        imagenes: especificacion.imagenes,
                        observaciones: especificacion.observaciones
                      });

                      /*imagenes.push({
                        ponderacion_id: especificacion.selected.id,
                        data: especificacion.imagenes,
                      })*/
                    });
                  });
                }));
              });

              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                // console.log(auditoria, imagenes)

                _this.$http.post('auditoria/all', auditoria).then(function (response) {
                  return !response || response.data.status !== 'OK' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('¡Algo sucedió! Porfavor vuelve a intentar guardar la auditoría.') : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
                }).then(function (response) {
                  if (response.status === 'OK') {
                    // Enviar notificacion.
                    _this.$http.post('auditoria/notify', {
                      type: 'nueva-auditoria',
                      username: _this.$user.data.name,
                      inmueble: _this.tree.inmueble.nombre
                    }).then(function (response) {
                      console.log(response);
                    });

                    _this.$toast.show('¡Auditoría guardada con éxito!');
                    _this.borrarAuditoriaActiva();
                    _this.$router.push('/');
                    _this.$loading.hide();
                    // this.$http.post('incidencias/new2', auditoria).then(response => {
                  }
                }, function (rejectMsg) {
                  _this.$toast.show(rejectMsg);
                  _this.$loading.hide();
                });
              });

              /* Old way de almacenar auditoria e incidencias...
              this.$http.post('auditoria/new', auditoria).then(response => {
                return !response || response.data.status !== 'OK'
                  ? Promise.reject('¡Algo sucedió! Porfavor vuelve a intentar guardar la auditoría.')
                  : Promise.resolve(response.data)
                }).then(data => {
                  let promises = []
                  areas.forEach(area => {
                    let send = {
                      incidencias: []
                    }
                      promises.push(
                      this.$idb.keyVal.getOnly('rubros', 'padreId', area.id).then(rubros => {
                      rubros.forEach(rubro => {
                        rubro.especificaciones.forEach(especificacion => {
                          let incidencia = {
                            ponderacion_id: especificacion.selected.id,
                            imagenes: especificacion.imagenes,
                            observaciones: especificacion.observaciones
                          }
                            send.incidencias.push(incidencia)
                        })
                      })
                        }).then(() => {
                          return this.$http.post('incidencia/new/' + data.auditoria_id, send)
                            .then(response => {
                              return response.data.status === 'OK'
                                ? Promise.resolve()
                                : Promise.reject('No se logró guardar una incidencia.')
                            })
                        })
                    )
                  })
                    Promise.all(promises).then(() => {
                    // enviar push notification a los jefes.
                    this.$http.post('auditoria/notify', {
                      type: 'nueva-auditoria',
                      username: this.$user.data.name,
                      inmueble: this.tree.inmueble.nombre
                    }).then(response => {
                      console.log(response)
                    })
                      this.borrarAuditoriaActiva()
                    this.$toast.show('¡Auditoría guardada con éxito!')
                    this.$router.push('/')
                  }, () => {
                    this.$toast.show('¡Algo sucedió! Porfavor vuelve a intentar guardar la auditoría.')
                  }).then(() => {
                    this.$loading.hide()
                  })
                }, rejectMsg => {
                    this.$toast.show(rejectMsg)
                    this.$loading.hide()
                })*/

              _this.$loading.show();
              _this.$toast.show('Enviando auditoría...');
            };

            _this.$dialog.show('Enviar Auditoría', 'Estás a punto de enviar la auditoría para su revisión, ¿deseas continuar?');
          },
          disabled: false
        }]
      }
    };
  },

  methods: {
    borrarAuditoriaActiva: function borrarAuditoriaActiva() {
      var _this2 = this;

      this.$idb.keyVal.getOnly('inmuebles', 'id', this.tree.inmueble.id).then(function (inmuebles) {
        inmuebles.forEach(function (inmueble) {
          inmueble.activo = 0;
          inmueble.promedio = 0;
          inmueble.incidencias = 0;
          _this2.$idb.keyVal.set('inmuebles', undefined, inmueble);

          _this2.$idb.keyVal.getOnly('areas', 'padreId', inmueble.id).then(function (areas) {
            areas.forEach(function (area) {
              area.puntos = 0;
              area.promedio = 0;
              area.incidencias = 0;
              _this2.$idb.keyVal.set('areas', undefined, area);

              _this2.$idb.keyVal.getOnly('rubros', 'padreId', area.id).then(function (rubros) {
                rubros.forEach(function (rubro) {
                  rubro.promedio = 0;
                  rubro.puntos = 0;
                  rubro.incidencias = 0;
                  rubro.especificaciones.forEach(function (especificacion) {
                    especificacion.imagenes = [];
                    especificacion.selected = {
                      id: especificacion.ponderaciones[0].id,
                      color: especificacion.ponderaciones[0].color,
                      valor: especificacion.ponderaciones[0].valor
                    };
                    especificacion.observaciones = '';
                  });
                  _this2.$idb.keyVal.set('rubros', undefined, rubro);
                });
              });
            });
          });
        });
      });

      this.$emit('activeAudit', false);
      this.$emit('goBack', -1);
      this.$actionbar.destroy();
    },
    calcularPromedio: function calcularPromedio() {
      var _this3 = this;

      var self = this,
          promises = [],
          areas = this.data,
          puntosInmueble = 0,
          areasConPromedio = 0,
          incidenciasInmueble = 0;

      areas.forEach(function (area) {
        promises.push(self.$idb.keyVal.getOnly('rubros', 'padreId', area.id).then(function (rubros) {
          if (!rubros.length) return;

          // Inicializando los valores.
          area.puntos = 0;
          area.incidencias = 0;

          // Sumando los promedios de cada rubro de esta area.
          rubros.forEach(function (rubro) {
            area.puntos += rubro.promedio;
            area.incidencias += isNaN(rubro.incidencias) ? 0 : rubro.incidencias;
          });

          // Calculando el promedio del area.
          area.promedio = Math.round10(area.puntos / rubros.length, -2);
          if (area.promedio === 0) return;

          // Definiendo los valores que se usaran para calcular el global.
          areasConPromedio += 1;
          puntosInmueble += area.promedio;
          incidenciasInmueble += area.incidencias;

          // Guardamos el area en idb.
          return _this3.$idb.keyVal.set('areas', undefined, area);
        }));
      });

      // Cuando se cumpla todo el proceso anterior, entonces si haz el siguiente calculo..
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        self.tree.inmueble.promedio = Math.round10(puntosInmueble / areasConPromedio, -2);
        self.tree.inmueble.incidencias = incidenciasInmueble;
        self.missing = areas.length - areasConPromedio;
        self.readyToSend = self.missing === 0;

        self.guardarTree();
        self.promedio = self.tree.inmueble.promedio;
      }, function () {
        self.$toast.show('¡Algo sucedió! Porfavor vuelve a guardar los resultados de esa área.');
      });
    },
    guardarTree: function guardarTree() {
      this.$emit('saveTree', this.tree);
    }
  },
  watch: {
    data: function data() {
      // console.log(this.data, 'watch')
      this.calcularPromedio();
      this.$actionbar.init(this.actionbar);
    }
  },
  mounted: function mounted() {
    // console.log(this.data, 'mounted')
    this.calcularPromedio();
    this.$actionbar.init(this.actionbar);
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'));
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Select__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Summary__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Summary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Summary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Audit__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Audit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Audit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'mdl-select': __WEBPACK_IMPORTED_MODULE_1__Select___default.a,
    'mdl-card': __WEBPACK_IMPORTED_MODULE_2__Card___default.a,
    'mdl-summary': __WEBPACK_IMPORTED_MODULE_3__Summary___default.a,
    'mdl-audit': __WEBPACK_IMPORTED_MODULE_4__Audit___default.a,
    'progress-bar': __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default.a
  },
  data: function data() {
    return {
      title: 'Auditoría',
      tree: { id: 1 },
      actionbar: {},
      activeAudit: false,
      currentIndex: 0,
      currentValue: 0,
      points: [],
      items: [{
        data: [],
        default: {
          fatherId: -1,
          name: 'Todas las Empresas',
          value: -1
        },
        id: 'empresas',
        loaded: [],
        resource: '/empresas',
        selected: {
          name: '',
          value: -1
        },
        types: ['select', 'card']
      }, {
        data: [],
        default: {
          fatherId: -1,
          name: 'Todas las Unidades de Negocio',
          value: -1
        },
        id: 'unidades-negocio',
        loaded: [],
        resource: '/unidadesnegocio/empresa/',
        selected: {
          name: '',
          value: -1
        },
        types: ['select', 'card']
      }, {
        data: [],
        default: {
          fatherId: -1,
          name: 'Todas los Inmuebles',
          value: -1
        },
        id: 'inmuebles',
        loaded: [],
        resource: '/inmuebles/unidadesnegocio/',
        selected: {
          name: '',
          value: -1
        },
        types: ['select', 'card']
      }, {
        data: [],
        default: {
          fatherId: -1,
          name: 'Todas las Áreas a Evaluar',
          value: -1
        },
        id: 'areas',
        loaded: [],
        resource: '/areas/inmuebles/',
        selected: {
          name: '',
          value: -1
        },
        types: ['select', 'summary']
      }, {
        data: [],
        default: {
          fatherId: -1,
          name: 'Todos los Rubros',
          value: -1
        },
        id: 'rubros',
        loaded: [],
        resource: '/rubros/areas/all/',
        selected: {
          name: '',
          value: -1
        },
        types: ['audit']
      }, {
        data: [],
        default: {
          fatherId: -1,
          name: 'Todos las Especificaciones',
          value: -1
        },
        id: 'especificaciones',
        loaded: [],
        resource: '/especificaciones/rubros/',
        selected: {
          name: '',
          value: -1
        },
        types: []
      }, {
        data: [],
        default: {
          fatherId: -1,
          name: 'Todos las Ponderaciones',
          value: -1
        },
        id: 'ponderaciones',
        loaded: [],
        resource: '/ponderaciones/especificaciones/',
        selected: {
          name: '',
          value: -1
        },
        types: []
      }],
      showProgress: false
    };
  },

  watch: {
    title: function title() {
      this.$title.show(this.title);
    },

    /* Active Audit Logic.
    activeAudit () {
      if (!this.activeAudit) {
        delete this.tree.inmueble
        delete this.tree.area
        this.$idb.keyVal.set('tree', undefined, this.tree)
      } else {
        this.tree.inmueble.activo = 1
        this.$idb.keyVal.set('inmuebles', undefined, this.tree.inmueble)
      }
    },*/
    currentIndex: function currentIndex() {
      var _this = this;

      // console.log(this.currentIndex)
      // aplicamos el primer filto booleano efectivo para los select
      this.items.forEach(function (item, index) {
        item.data = index <= _this.currentIndex ? item.data : []; // se muestran solo los true
        // aqui se redefine el valor del input (o select)
        item.selected.name = index >= _this.currentIndex ? item.default.name : item.selected.name;
        item.selected.value = index >= _this.currentIndex ? item.default.value : item.selected.value;
      });
    }
  },
  methods: {
    get: function get() {},
    changed: function changed(event) {
      var self = this,
          element = event.currentTarget || event,
          value = 1 * element.dataset.value,
          i = 1 * element.dataset.i,
          index = 1 * element.dataset.index,
          item = this.items[index],
          fatherId = 1 * element.dataset.fatherId,
          data = item.data[i],
          name = data ? data.nombre : element.dataset.text || element.textContent,

      // photo = element.dataset.photo,
      isDefault = !data;
      var parent = {},
          current = {};

      /* Active Audit Logic.
      if (this.activeAudit && !item.id.match(/areas|rubros/)) {
        return this.$toast.show('Favor de CANCELAR auditoría para regresar.')
      }*/

      this.$actionbar.destroy();
      // Armando el arbol de navegacion.
      switch (item.id) {
        case 'empresas':
          this.tree.empresa = data;
          break;
        case 'unidades-negocio':
          this.tree.unidadNegocio = data;
          break;
        case 'inmuebles':
          if (!isDefault) {
            data.incidencias = 0;
            data.promedio = 0;
            data.resumen = '';
          }
          this.tree.inmueble = data;
          break;
        case 'areas':
          this.tree.area = data;
          break;
      }

      this.$idb.keyVal.set('tree', undefined, this.tree);

      // Cambiar el value al select (en realidad es un input)
      this.items[index].selected.name = name;
      this.title = name;
      // Si se eligio el default (todos), el index es del mismo select,
      // si no, es el select hijo (o siguiente).
      this.currentIndex = isDefault ? index : index + 1;
      parent.item = this.items[this.currentIndex - 1];
      current.item = this.items[this.currentIndex];
      // Se define el fatherId del item elegido, para comparar ese id
      // con el fatherId de cada elemento ya cargado,
      // y asi solo mostrar los que coincidan.
      current.item.default.fatherId = isDefault ? current.item.default.fatherId : value;
      // es el value que se usara para obtener los recursos.
      this.currentValue = isDefault ? fatherId : value;
      this.items[index].selected.value = value;

      /* Definiendo funcion para realizar refresh */
      this.get = function () {
        var currentItem = self.items[self.currentIndex];
        var currentValue = currentItem.default.fatherId;
        var endpoint = currentValue === -1 ? currentItem.resource : currentItem.resource + currentValue;

        self.showProgress = true;
        self.$http.get(endpoint).then(function (response) {
          var data = response.data;

          self.$idb.keyVal.deleteOnly(currentItem.id, 'padreId', currentValue).then(function (deletedCount) {
            var promises = [];
            // Loop para agregar propiedades que solo se usaran en front.
            data.forEach(function (d) {
              switch (currentItem.id) {
                case 'inmuebles':
                  d.activo = 0;
                  d.puntos = 0;
                  d.promedio = 0;
                  // d.mantenimiento = d.mantenimiento
                  //   ? JSON.parse(d.mantenimiento)
                  //   : {}
                  break;

                case 'areas':
                  d.puntos = 0;
                  d.promedio = 0;
                  break;

                case 'rubros':
                  d.puntos = 0;
                  d.promedio = 0;
                  d.especificaciones.forEach(function (especificacion) {
                    especificacion.imagenes = [];
                    especificacion.selected = {
                      id: especificacion.ponderaciones[0].id,
                      color: especificacion.ponderaciones[0].color,
                      valor: especificacion.ponderaciones[0].valor
                    };
                    especificacion.observaciones = '';
                  });
                  break;
              }

              promises.push(self.$idb.keyVal.set(currentItem.id, undefined, d));
            });

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
              currentItem.data = data;
              self.showProgress = false;
            }, function () {
              self.$toast.show('¡Algo sucedió! Porfavor vuelve a realizar la misma operación.');
            });
          });
        }).catch(function (error) {
          self.$toast.show('No fue posible obtener la información del servidor.');
          self.showProgress = false;
        });
      };

      this.$endpoint.refresh(this.get);
      /* fin */

      // Evaluar si ya existe en IDB.
      this.$idb.keyVal.getOnly(current.item.id, 'padreId', this.currentValue).then(function (data) {
        if (data.length > 0) {
          return current.item.data = data;
        }

        self.get();
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var item = this.items[this.currentIndex];

    // Revisar si hay una auditoria activa.
    this.$idb.keyVal.getOnly('inmuebles', 'activo', 1).then(function (data) {

      if (data.length > 0) {
        var inmueble = data[0];

        _this2.$idb.keyVal.get('tree', 1).then(function (tree) {
          var promises = [];

          _this2.tree = tree;
          _this2.items[0].selected.name = tree.empresa.nombre;
          _this2.items[0].selected.value = tree.empresa.id;
          _this2.items[1].selected.name = tree.unidadNegocio.nombre;
          _this2.items[1].selected.value = tree.unidadNegocio.id;
          _this2.items[1].default.fatherId = tree.unidadNegocio.padreId;
          _this2.items[2].selected.name = tree.inmueble.nombre;
          _this2.items[2].selected.value = tree.inmueble.id;
          _this2.items[2].default.fatherId = tree.inmueble.padreId;
          _this2.items[3].default.fatherId = tree.inmueble.id;
          _this2.title = tree.inmueble.nombre;
          /* Active Audit Logic: this.activeAudit = true*/

          promises.push(_this2.$idb.keyVal.getOnly('empresas', 'padreId', tree.empresa.padreId).then(function (empresas) {
            _this2.items[0].data = empresas;
          }));

          promises.push(_this2.$idb.keyVal.getOnly('unidades-negocio', 'padreId', tree.unidadNegocio.padreId).then(function (unidadesNegocios) {
            _this2.items[1].data = unidadesNegocios;
          }));

          promises.push(_this2.$idb.keyVal.getOnly('inmuebles', 'padreId', tree.inmueble.padreId).then(function (inmuebles) {
            _this2.items[2].data = inmuebles;
          }));

          promises.push(_this2.$idb.keyVal.getOnly('areas', 'padreId', tree.inmueble.id).then(function (areas) {
            _this2.items[3].data = areas;
          }));

          promises.push(_this2.$idb.keyVal.getOnly('rubros', 'padreId', tree.area.id).then(function (rubros) {
            _this2.items[4].data = rubros;
          }));

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            _this2.currentIndex = 3;
          });
        });

        return;
      }

      _this2.$idb.keyVal.getAll(item.id).then(function (data) {
        if (data.length > 0) {
          return item.data = data;
        }

        _this2.get();
      }).catch(function (error) {
        console.log(error);
      });
    });

    this.get = function () {
      _this2.showProgress = true;
      return _this2.$http.get(item.resource).then(function (response) {
        var data = response.data;

        data.forEach(function (d) {
          _this2.$idb.keyVal.set(item.id, undefined, d);
        });

        item.data = data;
        _this2.showProgress = false;
      }).catch(function (error) {
        _this2.$toast.show('No fue posible obtener la información del servidor.');
        _this2.showProgress = false;
      });
    };
    this.$endpoint.refresh(this.get);

    // Cambiando el titulo.
    this.$title.show(this.title);
    this.$actionbar.destroy();
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      inputDisabled: true
    };
  },

  methods: {
    menuItemSelected: function menuItemSelected(event) {
      var menu = event.currentTarget,
          menuItem = event.target,
          menuInput = this.$el.querySelector('#menu-input'),
          textFilter = this.$el.querySelector('#text-filter');

      this.inputDisabled = false;
      // ¿Porque Dios?.. ligero delay para que el focus jale..
      setTimeout(function () {
        menuInput.value = menuItem.textContent;
        textFilter.dataset.filter = menuItem.dataset.filter;
        menu.MaterialMenu.toggle();
        textFilter.focus();
      }, 10);
    },
    search: function search(event) {
      var _this = this;

      var textFilter = event.currentTarget.type === 'text' ? event.currentTarget : this.$el.querySelector('#text-filter'),
          searchValue = textFilter.value,
          searchType = textFilter.dataset.filter;

      this.$emit('progress', true);
      this.$http.post('auditorias/newsfeed/search', {
        value: searchValue,
        type: searchType
      }).then(function (response) {
        _this.$emit('update', response.data);
      });
    }
  },
  mounted: function mounted() {
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'));
    componentHandler.upgradeElement(this.$el.querySelector('.mdl-button'));
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  data: function data() {
    var _this = this;

    return {
      actionbar: {
        show: true,
        buttons: [{
          text: 'Nueva Auditoria',
          onclick: function onclick() {
            _this.$router.push('auditoria');
          }
        }]
      }
    };
  },

  methods: {
    showReport: function showReport(event) {
      var auditorias = this.data.auditorias,
          index = event.currentTarget.dataset.index,
          auditoria = auditorias[index];

      if (auditoria.mantenimiento) {
        if (typeof auditoria.mantenimiento === 'string') {
          auditoria.mantenimiento = JSON.parse(auditoria.mantenimiento);
        }
      } else {
        auditoria.mantenimiento = {};
      }

      this.$emit('showReport', auditoria);
    }
  },
  mounted: function mounted() {
    this.$actionbar.init(this.actionbar);
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress___);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'progress-bar': __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress____default.a
  },
  props: ['audit'],
  data: function data() {
    var _this = this;

    return {
      title: 'Reporte de Auditoría',
      reportSrc: '',
      reportLoaded: false,
      incidencias: false,
      showReport: true,
      showProgress: false,
      points: 0,
      actionbar: {
        true: {
          show: true,
          buttons: [{
            text: 'Regresar',
            onclick: function onclick() {
              _this.$emit('showNewsfeed', true);
            }
          }]
        },
        false: {
          show: true,
          buttons: [{
            text: 'Regresar',
            onclick: function onclick() {
              _this.showReport = !_this.showReport;
            }
          }]
        }
      },
      observaciones: '',
      resumen: ''
    };
  },

  watch: {
    showReport: function showReport() {
      this.$actionbar.init(this.actionbar[this.showReport]);
    }
  },
  methods: {
    downloadReport: function downloadReport() {
      window.open(this.$http.defaults.baseURL + '/auditoria/pdf/' + this.audit.id + '/' + this.$user.data.id);
    },
    showReportOnScreen: function showReportOnScreen() {
      if (this.reportSrc !== '') {
        document.getElementById('iframeid').src += '';
        this.reportLoaded = false;
      }

      this.showProgress = true;
      this.reportSrc = this.$http.defaults.baseURL + '/auditoria/pdf/' + this.audit.id + '/' + this.$user.data.id;
    },
    showReportOnScreenEnd: function showReportOnScreenEnd() {
      if (this.reportSrc === '') return;
      this.showProgress = false;
      this.reportLoaded = true;
    },
    openChips: function openChips(event) {
      var chipsContainer = event.target.parentNode.querySelector('.mdl-chip__buttons'),
          currentChip = chipsContainer.parentNode.querySelector('.current-chip');

      chipsContainer.classList.add('mdl-chip__buttons--opened');
      currentChip.setAttribute('hidden', true);
    },
    chipSelected: function chipSelected(event) {
      var chipSelected = event.target,
          chipsContainer = chipSelected.parentNode,
          currentChip = chipsContainer.parentNode.querySelector('.current-chip'),
          content = currentChip.parentNode.parentNode,
          i = chipsContainer.dataset.i,
          incidencia = this.incidencias[i];

      incidencia.color = chipSelected.dataset.color;
      incidencia.update.ponderacion_id = chipSelected.dataset.id;
      chipsContainer.classList.remove('mdl-chip__buttons--opened');
      currentChip.removeAttribute('hidden');
    },
    uploadPhoto: function uploadPhoto(event) {
      event.currentTarget.querySelector('input[type="file"]').click();
    },
    imageToDataUri: function imageToDataUri(img, width, height, quality) {
      // create an off-screen canvas
      var canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');

      // set its dimension to target size
      canvas.width = width;
      canvas.height = height;

      // draw source image into the off-screen canvas:
      ctx.drawImage(img, 0, 0, width, height);

      // encode image to data-uri with base64 version of compressed image
      return canvas.toDataURL('image/jpeg', quality);
    },
    showPicture: function showPicture(event) {
      // spinner.classList.remove('hidden');
      // selectPicture.disabled = true;
      // Get a reference to the taken picture or chosen file
      var self = this;
      var fileInput = event.target,
          files = fileInput.files,
          file = void 0,
          fileSize = void 0,
          fileReader = new FileReader(),
          i = fileInput.dataset.i,
          incidencia = this.incidencias[i];

      if (incidencia.update.imagenes.length >= 3) {
        return this.$toast.show('Ha alcanzado el máximo de imágenes por incidencia.');
      }

      if (files && files.length > 0) {
        file = files[0];
        fileSize = file.size;

        fileReader.onload = function (event) {
          var img = new Image(),
              newDataUri = void 0;

          img.onload = function (i) {
            newDataUri = fileSize > 3000000 ? self.imageToDataUri(img, img.width * 0.25, img.height * 0.25, 0.3) : newDataUri = self.imageToDataUri(img, img.width * 0.5, img.height * 0.5, 0.4);

            incidencia.update.imagenes.push(newDataUri);
          };

          img.src = fileReader.result;
        };
        fileReader.readAsDataURL(file);
      } else {
        // Aqui la imagen se crea y luego te destruye.
        // spinner.classList.add('hidden');
        // selectPicture.disabled = false;
      }
    },
    showOldPictures: function showOldPictures(event) {
      var _this2 = this;

      var button = event.currentTarget,
          i = button.dataset.i,
          incidencia = this.incidencias[i],
          origen = incidencia.origen,
          container = document.createElement('div'),
          count = 0;

      this.$loading.show();
      incidencia.imagenes.forEach(function (src) {
        var img = new Image();
        img.onload = function () {
          img.style.padding = '10px';
          container.appendChild(img);
          count += 1;

          if (count === incidencia.imagenes.length) {
            _this2.$dialog.accept = function () {};
            _this2.$dialog.show('Imágenes Anteriores', container.outerHTML, true);
            _this2.$loading.hide();
          }
        };
        img.src = origen + src;
      });
    },
    downloadPicture: function downloadPicture(event) {
      var downloadButton = event.currentTarget,
          i = downloadButton.dataset.i,
          k = downloadButton.dataset.k,
          incidencia = this.incidencias[i],
          imagenes = incidencia.update.imagenes,
          anchor = document.createElement('a');
      // url = imagenes[k].replace(/^data:image\/[^;]+/, 'data:application/octet-stream'),
      // win = window.open(imagenes[k], '_blank')

      anchor.href = 'https://appauditoria.gtglobal.com/storage/auditorias/' + imagenes[k];
      anchor.target = '_blank';
      anchor.download = this.audit.inmueble + '__' + incidencia.area + '__' + incidencia.rubro + '__' + incidencia.especificacion + '__' + imagenes.length;

      return anchor.click();

      // image.src = imagenes[k]

      // return win.document.write(image.outerHTML)
      // return window.open(imagenes[k], '_blank')
    },
    removePicture: function removePicture(event) {
      var deleteButton = event.currentTarget,
          i = deleteButton.dataset.i,
          k = deleteButton.dataset.k,
          incidencia = this.incidencias[i],
          imagenes = incidencia.update.imagenes;

      return imagenes.splice(k, 1);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    // console.log(this.audit)
    if (this.audit.statusId === 2) {
      var loadButton = {
        text: 'Ver Incidencias',
        onclick: function onclick() {
          _this3.showReport = false;
          _this3.$http.get('incidencias/' + _this3.audit.id).then(function (response) {
            var data = response.data;
            _this3.incidencias = data;

            _this3.$emit('showProgress', false);
            setTimeout(function () {
              componentHandler.upgradeElements(_this3.$el.querySelectorAll('.mdl-textfield'));
            }, 200);
          });
          _this3.incidencias = [];
          _this3.$emit('showProgress', true);
        }
      },
          sendButton = {
        text: 'Enviar Revaluación',
        onclick: function onclick() {
          var incidences = document.querySelectorAll('.incidence');

          for (var i = 0; i < incidences.length; i++) {
            if (incidences[i].style.display !== 'none') {
              var textfield = incidences[i].querySelector('.mdl-textfield__input');
              var photos = incidences[i].querySelector('.photos');

              if (textfield.value === '') {
                return _this3.$toast.show('Favor de escribir tus observaciones en cada incidencia.');
              } else if (photos.childElementCount === 0) {
                return _this3.$toast.show('Favor de asignar mínimo una fotografía en cada incidencia.');
              }
            }
          }

          if (_this3.resumen === '') {
            return _this3.$toast.show('Favor de escribir el resumen de la revaluación.');
          }

          _this3.$dialog.accept = function () {
            _this3.$loading.show();

            var incidenciasUpdated = [];
            _this3.incidencias.forEach(function (incidencia) {
              incidenciasUpdated.push(incidencia.update);
            });

            _this3.$http.post('auditoria/revaluate/' + _this3.audit.id, {
              'auditoria_id': _this3.audit.id,
              'resumen': _this3.resumen,
              'incidencias': incidenciasUpdated
            }).then(function (response) {
              _this3.$loading.hide();
              if (response.data.status === 'OK') {
                // enviar push notification a los jefes.
                _this3.$http.post('auditoria/notify', {
                  type: 'reval-auditoria',
                  username: _this3.$user.data.name,
                  inmueble: _this3.audit.inmueble
                }).then(function (response) {
                  console.log(response);
                });

                _this3.$emit('showNewsfeed', true);
              }
            }).catch(function (error) {
              _this3.$loading.hide();
              _this3.$toast.show('¡Algo sucedió! Porfavor, vuelve a intentarlo.');
            });
          };

          _this3.$dialog.show('Enviar Revaluación', 'Estás a punto de enviar la revaluación de las incidencias, ¿deseas continuar?');
        }
      };

      this.actionbar.true.buttons.push(loadButton);
      this.actionbar.false.buttons.push(sendButton);
    }

    this.resumen = this.audit.resumen;

    this.$endpoint.destroy();
    this.$actionbar.init(this.actionbar.true);
    this.$title.show(this.title + ': ' + this.audit.inmueble);

    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'));
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    formatDate: function formatDate() {
      var date = new Date(),
          monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          day = date.getDate(),
          monthIndex = date.getMonth(),
          year = date.getFullYear();

      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Welcome__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filter__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Report__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'welcome-message': __WEBPACK_IMPORTED_MODULE_0__Welcome___default.a,
    'list': __WEBPACK_IMPORTED_MODULE_1__List___default.a,
    'list-filter': __WEBPACK_IMPORTED_MODULE_2__Filter___default.a,
    'empty-newsfeed': __WEBPACK_IMPORTED_MODULE_3__Empty___default.a,
    'audit-report': __WEBPACK_IMPORTED_MODULE_4__Report___default.a,
    'progress-bar': __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default.a
  },
  data: function data() {
    return {
      title: 'Newsfeed',
      newsfeed: [],
      showProgress: true,
      showProgress2: false,
      showNewsfeed: true,
      clickedAudit: {}
    };
  },

  watch: {
    showNewsfeed: function showNewsfeed() {
      this.getNewsfeed();
      this.$title.show(this.title);
    }
  },
  methods: {
    getNewsfeed: function getNewsfeed() {
      var _this = this;

      this.showProgress = true;

      this.$http.get('auditorias/newsfeed/10').then(function (response) {
        _this.newsfeed = response.data;
        return _this.showProgress = false;
      }).catch(function (error) {
        _this.showProgress = false;
      });
    },
    updateNewsfeed: function updateNewsfeed(newsfeed) {
      this.newsfeed = newsfeed;
      this.showProgress = false;
    },
    showReport: function showReport($event) {
      this.clickedAudit = $event;
      this.showNewsfeed = false;
    }
  },
  mounted: function mounted() {
    this.$http.defaults.headers.common['Authorization'] = this.$user.data.email;
    this.getNewsfeed();
    this.$endpoint.refresh(this.getNewsfeed);
    this.$title.show(this.title);
    this.$actionbar.destroy();
    componentHandler.upgradeDom();
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      inputDisabled: true
    };
  },

  methods: {
    menuItemSelected: function menuItemSelected(event) {
      var menu = event.currentTarget,
          menuItem = event.target,
          menuInput = this.$el.querySelector('#menu-input'),
          textFilter = this.$el.querySelector('#text-filter');

      this.inputDisabled = false;
      // ¿Porque Dios?.. ligero delay para que el focus jale..
      setTimeout(function () {
        menuInput.value = menuItem.textContent;
        textFilter.dataset.filter = menuItem.dataset.filter;
        menu.MaterialMenu.toggle();
        textFilter.focus();
      }, 10);
    },
    search: function search(event) {
      var _this = this;

      var textFilter = event.currentTarget.type === 'text' ? event.currentTarget : this.$el.querySelector('#text-filter'),
          searchValue = textFilter.value,
          searchType = textFilter.dataset.filter;

      this.$emit('progress', true);
      this.$http.post('auditorias/newsfeed/search', {
        value: searchValue,
        type: searchType
      }).then(function (response) {
        _this.$emit('update', response.data);
      });
    }
  },
  mounted: function mounted() {
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'));
    componentHandler.upgradeElement(this.$el.querySelector('.mdl-button'));
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  data: function data() {
    return {
      actionbar: {}
    };
  },

  methods: {
    showReport: function showReport(event) {
      var item = event.currentTarget,
          itemParent = event.currentTarget.parentNode,
          auditores = this.data.auditores,
          itemIndex = item.dataset.index,
          itemParentIndex = itemParent.dataset.index,
          auditoria = auditores[itemParentIndex].auditorias[itemIndex];

      if (auditoria.mantenimiento) {
        if (typeof auditoria.mantenimiento === 'string') {
          auditoria.mantenimiento = JSON.parse(auditoria.mantenimiento);
        }
      } else {
        auditoria.mantenimiento = {};
      }

      this.$emit('showReport', auditoria);
    }
  },
  mounted: function mounted() {
    this.$actionbar.init(this.actionbar);
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress___);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'progress-bar': __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress____default.a
  },
  props: ['audit'],
  data: function data() {
    var _this = this;

    return {
      title: 'Reporte de Auditoría',
      reportSrc: '',
      reportLoaded: false,
      incidencias: false,
      showReport: true,
      showProgress: false,
      points: 0,
      actionbar: {
        true: {
          show: true,
          buttons: [{
            text: 'Regresar',
            onclick: function onclick() {
              _this.$emit('showNewsfeed', true);
            }
          }]
        },
        false: {
          show: true,
          buttons: [{
            text: 'Regresar',
            onclick: function onclick() {
              _this.showReport = !_this.showReport;
            }
          }]
        }
      }
    };
  },

  watch: {
    showReport: function showReport() {
      this.$actionbar.init(this.actionbar[this.showReport]);
    }
  },
  methods: {
    downloadReport: function downloadReport() {
      window.open(this.$http.defaults.baseURL + '/auditoria/pdf/' + this.audit.id + '/' + this.$user.data.id);
    },
    showReportOnScreen: function showReportOnScreen() {
      if (this.reportSrc !== '') {
        document.getElementById('iframeid').src += '';
        this.reportLoaded = false;
      }

      this.showProgress = true;
      this.reportSrc = this.$http.defaults.baseURL + '/auditoria/pdf/' + this.audit.id + '/' + this.$user.data.id;
    },
    showReportOnScreenEnd: function showReportOnScreenEnd() {
      if (this.reportSrc === '') return;
      this.showProgress = false;
      this.reportLoaded = true;
    },
    downloadPicture: function downloadPicture(event) {
      var downloadButton = event.currentTarget,
          i = downloadButton.dataset.i,
          k = downloadButton.dataset.k,
          incidencia = this.incidencias[i],
          imagenes = incidencia.imagenes.split(','),
          anchor = document.createElement('a');
      // url = imagenes[k].replace(/^data:image\/[^;]+/, 'data:application/octet-stream'),
      // win = window.open(imagenes[k], '_blank')

      anchor.href = 'https://appauditoria.gtglobal.com/storage/auditorias/' + imagenes[k];
      anchor.target = '_blank';
      anchor.download = this.audit.inmueble + '__' + incidencia.area + '__' + incidencia.rubro + '__' + incidencia.especificacion + '__' + imagenes.length;

      return anchor.click();

      // image.src = imagenes[k]

      // return win.document.write(image.outerHTML)
      // return window.open(imagenes[k], '_blank')
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.audit.statusId === 1) {
      var loadButton = {
        text: 'Ver Incidencias',
        onclick: function onclick() {
          _this2.showReport = false;
          _this2.$http.get('incidencias/' + _this2.audit.id).then(function (response) {
            var data = response.data;
            data.forEach(function (d) {
              d.revaluacion = {
                aprobado: true,
                observaciones: ''
              };
            });

            _this2.incidencias = data;
          }).then(function () {
            componentHandler.upgradeElements(_this2.$el.querySelectorAll('.mdl-checkbox'));
            componentHandler.upgradeElements(_this2.$el.querySelectorAll('.mdl-textfield'));
            componentHandler.upgradeElements(_this2.$el.querySelectorAll('.mdl-button'));

            _this2.$emit('showProgress', false);
          });
          _this2.$emit('showProgress', true);
        }
      },
          sendButton = {
        text: 'Enviar Evaluación',
        onclick: function onclick() {
          var checkedBoxes = document.querySelectorAll('.mdl-checkbox__input:checked');

          for (var i = 0; i < checkedBoxes.length; i++) {
            var parent = checkedBoxes[i].parentNode;
            while (!parent.classList.contains('revaluacion')) {
              parent = parent.parentNode;
            }

            if (parent.querySelector('.mdl-textfield__input').value === '') {
              return _this2.$toast.show('Favor de escribir tu REVALUACION en cada incidencia.');
            }
          }

          _this2.$dialog.accept = function () {
            _this2.$http.post('aprobacion', {
              'auditoria_id': _this2.audit.id,
              'incidencias': _this2.incidencias
            }).then(function (response) {
              if (response.data.status === 'OK') {
                _this2.$http.post('auditoria/notify', {
                  type: 'jefe-auditoria',
                  username: _this2.$user.data.name,
                  inmueble: _this2.audit.inmueble,
                  statusId: response.data.auditoria.statusId
                }).then(function (response) {
                  // console.log(response)
                });

                _this2.$toast.show('¡Auditoría evaluada con éxito!');
                _this2.$emit('showNewsfeed', true);
              }
            }).then(function () {
              _this2.$loading.hide();
            });

            _this2.$loading.show();
            _this2.$toast.show('Enviando evaluación de la auditoría...');
          };

          _this2.$dialog.show('Enviar Evaluación', 'Estás a punto de enviar la evaluación de esta auditoría. Si por lo menos existe' + ' una INCIDENCIA para reevaluar, la auditoría obtendrá el estatus de REEVALUACION.' + ' Por el contrario, se tomará como auditoría APROBADA, ¿deseas continuar?');
        }
      };

      this.actionbar.true.buttons.push(loadButton);
      this.actionbar.false.buttons.push(sendButton);
    }

    this.$endpoint.destroy();
    this.$actionbar.init(this.actionbar.true);
    this.$title.show(this.title + ': ' + this.audit.inmueble);

    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'));
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    formatDate: function formatDate() {
      var date = new Date(),
          monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          day = date.getDate(),
          monthIndex = date.getMonth(),
          year = date.getFullYear();

      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Welcome__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filter__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Report__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'welcome-message': __WEBPACK_IMPORTED_MODULE_0__Welcome___default.a,
    'list': __WEBPACK_IMPORTED_MODULE_1__List___default.a,
    'list-filter': __WEBPACK_IMPORTED_MODULE_2__Filter___default.a,
    'empty-newsfeed': __WEBPACK_IMPORTED_MODULE_3__Empty___default.a,
    'audit-report': __WEBPACK_IMPORTED_MODULE_4__Report___default.a,
    'progress-bar': __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default.a
  },
  data: function data() {
    return {
      title: 'Newsfeed',
      newsfeed: false,
      showProgress: true,
      showProgress2: false,
      showNewsfeed: true,
      clickedAudit: {}
    };
  },

  watch: {
    showNewsfeed: function showNewsfeed() {
      this.getNewsfeed();
      this.$title.show(this.title);
    }
  },
  methods: {
    getNewsfeed: function getNewsfeed() {
      var _this = this;

      this.showProgress = true;
      this.$http.get('auditorias/newsfeed/10').then(function (response) {
        _this.newsfeed = response.data;
        return _this.showProgress = false;
      }).catch(function (error) {
        _this.showProgress = false;
      });
    },
    updateNewsfeed: function updateNewsfeed(newsfeed) {
      this.newsfeed = newsfeed;
      this.showProgress = false;
    },
    showReport: function showReport($event) {
      this.clickedAudit = $event;
      this.showNewsfeed = false;
    }
  },
  mounted: function mounted() {
    this.$http.defaults.headers.common['Authorization'] = this.$user.data.email;
    this.getNewsfeed();
    this.$endpoint.refresh(this.getNewsfeed);
    this.$title.show(this.title);
    this.$actionbar.destroy();
    componentHandler.upgradeDom();
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      inputDisabled: true
    };
  },

  methods: {
    menuItemSelected: function menuItemSelected(event) {
      var menu = event.currentTarget,
          menuItem = event.target,
          menuInput = this.$el.querySelector('#menu-input'),
          textFilter = this.$el.querySelector('#text-filter');

      this.inputDisabled = false;
      // ¿Porque Dios?.. ligero delay para que el focus jale..
      setTimeout(function () {
        menuInput.value = menuItem.textContent;
        textFilter.dataset.filter = menuItem.dataset.filter;
        menu.MaterialMenu.toggle();
        textFilter.focus();
      }, 10);
    },
    search: function search(event) {
      var _this = this;

      var textFilter = event.currentTarget.type === 'text' ? event.currentTarget : this.$el.querySelector('#text-filter'),
          searchValue = textFilter.value,
          searchType = textFilter.dataset.filter;

      this.$emit('progress', true);
      this.$http.post('auditorias/newsfeed/search', {
        value: searchValue,
        type: searchType
      }).then(function (response) {
        _this.$emit('update', response.data);
      });
    }
  },
  mounted: function mounted() {
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'));
    componentHandler.upgradeElement(this.$el.querySelector('.mdl-button'));
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  data: function data() {
    return {
      actionbar: {}
    };
  },

  methods: {
    showReport: function showReport(event) {
      var auditorias = this.data.auditorias,
          index = event.currentTarget.dataset.index,
          auditoria = auditorias[index];

      if (auditoria.mantenimiento) {
        if (typeof auditoria.mantenimiento === 'string') {
          auditoria.mantenimiento = JSON.parse(auditoria.mantenimiento);
        }
      } else {
        auditoria.mantenimiento = {};
      }

      this.$emit('showReport', auditoria);
    }
  },
  mounted: function mounted() {
    this.$actionbar.init(this.actionbar);
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress___);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'progress-bar': __WEBPACK_IMPORTED_MODULE_0__components_Shared_Progress____default.a
  },
  props: ['audit'],
  data: function data() {
    var _this = this;

    return {
      title: 'Reporte de Auditoría',
      reportSrc: '',
      reportLoaded: false,
      incidencias: false,
      showReport: true,
      showProgress: false,
      points: 0,
      actionbar: {
        true: {
          show: true,
          buttons: [{
            text: 'Regresar',
            onclick: function onclick() {
              _this.$emit('showNewsfeed', true);
            }
          }]
        },
        false: {
          show: true,
          buttons: [{
            text: 'Regresar',
            onclick: function onclick() {
              _this.showReport = !_this.showReport;
            }
          }]
        }
      }
    };
  },

  watch: {
    showReport: function showReport() {
      this.$actionbar.init(this.actionbar[this.showReport]);
    }
  },
  methods: {
    downloadReport: function downloadReport() {
      window.open(this.$http.defaults.baseURL + '/auditoria/pdf/' + this.audit.id + '/' + this.$user.data.id);
    },
    showReportOnScreen: function showReportOnScreen() {
      if (this.reportSrc !== '') {
        document.getElementById('iframeid').src += '';
        this.reportLoaded = false;
      }

      this.showProgress = true;
      this.reportSrc = this.$http.defaults.baseURL + '/auditoria/pdf/' + this.audit.id + '/' + this.$user.data.id;
    },
    showReportOnScreenEnd: function showReportOnScreenEnd() {
      if (this.reportSrc === '') return;
      this.showProgress = false;
      this.reportLoaded = true;
    },
    downloadPicture: function downloadPicture(event) {
      var downloadButton = event.currentTarget,
          i = downloadButton.dataset.i,
          k = downloadButton.dataset.k,
          incidencia = this.incidencias[i],
          imagenes = incidencia.imagenes.split(','),
          anchor = document.createElement('a');
      // url = imagenes[k].replace(/^data:image\/[^;]+/, 'data:application/octet-stream'),
      // win = window.open(imagenes[k], '_blank')

      anchor.href = 'https://appauditoria.gtglobal.com/storage/auditorias/' + imagenes[k];
      anchor.target = '_blank';
      anchor.download = this.audit.inmueble + '__' + incidencia.area + '__' + incidencia.rubro + '__' + incidencia.especificacion + '__' + imagenes.length;

      return anchor.click();

      // image.src = imagenes[k]

      // return win.document.write(image.outerHTML)
      // return window.open(imagenes[k], '_blank')
    },
    onlyNumbers: function onlyNumbers(event) {
      var validKeyCodes = [8, 9, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 190];

      return validKeyCodes.includes(event.keyCode) ? event : event.preventDefault();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.audit.statusId === 3) {
      var loadButton = {
        text: 'Ver Incidencias',
        onclick: function onclick() {
          _this2.showReport = false;
          _this2.$http.get('incidencias/' + _this2.audit.id).then(function (response) {
            var data = response.data;
            data.forEach(function (d) {
              d.planTrabajo = d.planTrabajo ? JSON.parse(d.planTrabajo) : {
                descripcion: '',
                duracion: '',
                costo: ''
              };
            });

            _this2.incidencias = data;
          }).then(function () {
            componentHandler.upgradeElements(_this2.$el.querySelectorAll('.mdl-checkbox'));
            componentHandler.upgradeElements(_this2.$el.querySelectorAll('.mdl-textfield'));
            componentHandler.upgradeElements(_this2.$el.querySelectorAll('.mdl-button'));

            _this2.$emit('showProgress', false);
          });
          _this2.$emit('showProgress', true);
        }
      },
          sendButton = {
        text: 'Enviar Plan de Trabajo',
        onclick: function onclick() {
          var textfields = document.querySelectorAll('.mdl-textfield__input');

          for (var i in textfields) {
            if (textfields[i].value === '') {
              return _this2.$toast.show('Favor de escribir tu PLAN DE TRABAJO en cada incidencia.');
            }
          }

          _this2.$dialog.accept = function () {
            _this2.$http.post('mantenimiento', {
              'auditoria_id': _this2.audit.id,
              'incidencias': _this2.incidencias
            }).then(function (response) {
              if (response.data === 'OK') {
                _this2.$http.post('auditoria/notify', {
                  type: 'plan-trabajo-auditoria',
                  username: _this2.$user.data.name,
                  inmueble: _this2.audit.inmueble
                }).then(function (response) {
                  // console.log(response)
                });

                _this2.$toast.show('¡Plan de Trabajo enviado con éxito!');
                _this2.$emit('showNewsfeed', true);
              }
            }).then(function () {
              _this2.$loading.hide();
            });

            _this2.$loading.show();
            _this2.$toast.show('Enviando plan de trabajo...');
          };

          _this2.$dialog.show('Enviar Plan de Trabajo', 'Estás a punto de enviar el PLAN DE TRABAJO para solucionar ' + ' las incidencias de esta auditoría, ¿deseas continuar?');
        }
      };

      this.actionbar.true.buttons.push(loadButton);
      this.actionbar.false.buttons.push(sendButton);
    }

    this.$endpoint.destroy();
    this.$actionbar.init(this.actionbar.true);
    this.$title.show(this.title + ': ' + this.audit.inmueble);

    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'));
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    formatDate: function formatDate() {
      var date = new Date(),
          monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          day = date.getDate(),
          monthIndex = date.getMonth(),
          year = date.getFullYear();

      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Welcome__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filter__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Report__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress___);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'welcome-message': __WEBPACK_IMPORTED_MODULE_0__Welcome___default.a,
    'list': __WEBPACK_IMPORTED_MODULE_1__List___default.a,
    'list-filter': __WEBPACK_IMPORTED_MODULE_2__Filter___default.a,
    'empty-newsfeed': __WEBPACK_IMPORTED_MODULE_3__Empty___default.a,
    'audit-report': __WEBPACK_IMPORTED_MODULE_4__Report___default.a,
    'progress-bar': __WEBPACK_IMPORTED_MODULE_5__components_Shared_Progress____default.a
  },
  data: function data() {
    return {
      title: 'Newsfeed',
      newsfeed: [],
      showProgress: true,
      showProgress2: false,
      showNewsfeed: true,
      clickedAudit: {}
    };
  },

  watch: {
    showNewsfeed: function showNewsfeed() {
      this.getNewsfeed();
      this.$title.show(this.title);
    }
  },
  methods: {
    getNewsfeed: function getNewsfeed() {
      var _this = this;

      this.showProgress = true;
      this.$http.get('auditorias/newsfeed/10').then(function (response) {
        _this.newsfeed = response.data;
        return _this.showProgress = false;
      }).catch(function (error) {
        _this.showProgress = false;
      });
    },
    updateNewsfeed: function updateNewsfeed(newsfeed) {
      this.newsfeed = newsfeed;
      this.showProgress = false;
    },
    showReport: function showReport($event) {
      this.clickedAudit = $event;
      this.showNewsfeed = false;
    }
  },
  mounted: function mounted() {
    this.$http.defaults.headers.common['Authorization'] = this.$user.data.email;
    this.getNewsfeed();
    this.$endpoint.refresh(this.getNewsfeed);
    this.$title.show(this.title);
    this.$actionbar.destroy();
    componentHandler.upgradeDom();
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      buttons: []
    };
  },

  methods: {
    init: function init(actionbar) {
      this.show = actionbar.show;
      this.buttons = actionbar.buttons;
    },
    destroy: function destroy() {
      this.show = false;
      this.buttons = [];
    }
  },
  mounted: function mounted() {
    this.$actionbar.init = this.init;
    this.$actionbar.destroy = this.destroy;
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: {
        el: '',
        title: '',
        content: '',
        isHTML: false
      }
    };
  },

  methods: {
    show: function show(title, content, isHTML) {
      this.dialog.title = title;
      this.dialog.content = content;
      this.dialog.el.showModal();
      this.dialog.isHTML = isHTML;
    },
    accept: function accept() {
      this.$dialog.accept();
    }
  },
  mounted: function mounted() {
    var dialog = document.querySelector('#dialog');

    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }

    dialog.querySelector('.mdl-dialog__actions').addEventListener('click', function (event) {
      if (event.target.classList.contains('mdl-button')) {
        dialog.close();
      }
    });

    this.dialog.el = dialog;
    this.$dialog.show = this.show;
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      links: []
    };
  },

  methods: {
    toggleDrawer: function toggleDrawer() {
      document.querySelector('.mdl-layout').MaterialLayout.toggleDrawer();
    },
    signOut: function signOut() {
      var _this = this;

      var auth2 = gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
        _this.$idb.keyVal.clear('login').then(function () {
          window.location.reload();
        });
      });

      this.$loading.show();
    }
  },
  mounted: function mounted() {
    var self = this;
    switch (this.$user.data.roleCode) {
      case 'auditor':
        this.links = [{ to: '/', icon: 'dvr', name: 'Newsfeed' }, { to: '/auditoria', icon: 'place', name: 'Auditoría' }, { to: '/mi-perfil', icon: 'people', name: 'Perfil' }];
        break;
      case 'jefe':
        this.links = [{ to: '/', icon: 'dvr', name: 'Newsfeed' }, { to: '/mi-perfil', icon: 'people', name: 'Perfil' }];
        break;

      case 'mantenimiento':
        this.links = [{ to: '/', icon: 'dvr', name: 'Newsfeed' }, { to: '/mi-perfil', icon: 'people', name: 'Perfil' }];
        break;
    }

    gapi.load('auth2', function () {
      gapi.auth2.init().then(function (googleAuth) {
        var googleUser = googleAuth.currentUser.get(),
            authResponse = googleUser.getAuthResponse(),
            idToken = authResponse.id_token,
            isNewToken = self.$user.data.idToken !== idToken;

        if (isNewToken) {
          self.$user.data.idToken = idToken;
          return self.$idb.keyVal.set('login', undefined, self.$user.data);
        }
      });
    });

    componentHandler.upgradeElement(this.$el);
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '',
      endpoint: ''
    };
  },

  methods: {
    show: function show(title) {
      this.title = title;
    },
    asignRefresh: function asignRefresh(request) {
      this.refresh = request;
    },
    refresh: function refresh() {},
    destroy: function destroy() {
      this.refresh = function () {};
    },
    buscarAuditoria: function buscarAuditoria(event) {
      var form = event.currentTarget,
          value = form['buscar-auditoria'].value;
    }
  },
  mounted: function mounted() {
    this.$title.show = this.show;
    this.$endpoint.refresh = this.asignRefresh;
    this.$endpoint.destroy = this.destroy;
    componentHandler.upgradeElement(this.$el);
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionBar___ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionBar____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ActionBar___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Drawer___ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Drawer____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Drawer___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer___ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Footer___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header___ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Header___);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    'app-action-bar': __WEBPACK_IMPORTED_MODULE_0__ActionBar____default.a,
    'app-drawer': __WEBPACK_IMPORTED_MODULE_1__Drawer____default.a,
    'app-footer': __WEBPACK_IMPORTED_MODULE_2__Footer____default.a,
    'app-header': __WEBPACK_IMPORTED_MODULE_3__Header____default.a
  },
  mounted: function mounted() {
    componentHandler.upgradeElement(this.$el);
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      flag: true
    };
  },

  methods: {
    show: function show() {
      return this.flag = true;
    },
    hide: function hide() {
      return this.flag = false;
    }
  },
  mounted: function mounted() {
    this.$loading.show = this.show;
    this.$loading.hide = this.hide;
    componentHandler.upgradeElement(this.$el);
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      signinText: 'Iniciar Sesión'
    };
  },

  methods: {
    onSuccess: function onSuccess(googleUser) {
      // return googleUser.disconnect()
      var self = this;
      self.$loading.show();
      var basicProfile = googleUser.getBasicProfile(),
          authResponse = googleUser.getAuthResponse(),
          user = {
        gid: basicProfile.getId(),
        name: basicProfile.getName(),
        givenName: basicProfile.getGivenName(),
        familyName: basicProfile.getFamilyName(),
        email: basicProfile.getEmail(),
        avatar: basicProfile.getImageUrl(),
        // accessToken: authResponse.access_token,
        idToken: authResponse.id_token

        // Callback called when tags have finished sending
      };self.$http.defaults.headers.common['Authorization'] = user.email; // user.idToken
      self.$http.get('/login?email=' + user.email + '&avatar=' + user.avatar).then(function (response) {
        var data = response.data;

        if (data.success.match(/1/)) {
          user.id = data.response.id;
          user.role = data.response.role;
          user.roleCode = data.response.roleCode;

          // Save user on global and on idb.
          self.$user.data = user;
          return self.$idb.keyVal.set('login', undefined, user).then(function () {
            OneSignal.push(function () {
              OneSignal.isPushNotificationsEnabled(function (isEnabled) {
                if (isEnabled) {
                  console.log("Push notifications are enabled!");
                  OneSignal.sendTag('role', user.role);
                } else {
                  self.$toast.show('Las notificaciones push no estan habilitadas.');
                  console.log("Push notifications are not enabled yet.");
                  OneSignal.registerForPushNotifications();
                  // self.$loading.hide()
                }
              });
            });

            // Send the user to Home page.
            self.$toast.show('Bienvenido ' + user.name + '.');
            self.$emit('viewChanged', 'Home');
            self.$loading.hide();
          }).catch(function () {
            self.$toast.show('Algo sucedió, porfavor vuelve a intentarlo.');
            self.$loading.hide();
          });
        }

        googleUser.disconnect();
        self.$loading.hide();
        return self.$toast.show(data.response);
      }).catch(function () {
        googleUser.disconnect();
        self.$loading.hide();
      });
    },
    onFailure: function onFailure(error) {
      this.$toast.show('¡Algo sucedió! Vuelve a intentar iniciar sesión, porfavor.');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$loading.show();
    self.$idb.keyVal.getAll('login').then(function (response) {
      self.$loading.hide();

      if (response.length > 0) {
        self.$user.data = response[0];
        return self.$emit('viewChanged', 'Home');
      }

      gapi.load('auth2', function () {
        gapi.auth2.init().then(function (googleAuth) {
          var googleSignInButton = document.querySelector('#google-signin');
          googleAuth.attachClickHandler(googleSignInButton, {}, self.onSuccess, self.onFailure);
        });
      });

      /*gapi.signin2.render('google-signin', {
        'scope': 'profile email',
        'width': 240,
        'height': 40,
        'longtitle': true,
        'theme': 'light',
        'onsuccess': self.onSuccess,
        'onfailure': self.onFailure
      });*/
    });

    componentHandler.upgradeElement(this.$el);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: 'Mi Perfil'
    };
  },

  methods: {},
  mounted: function mounted() {
    this.$endpoint.destroy();
    this.$title.show(this.title);
    // console.log(this.$endpoint)
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    componentHandler.upgradeElement(this.$el.childNodes[0]);
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: 'Mis Reportes'
    };
  },
  mounted: function mounted() {
    this.$title.show(this.title);
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    init: function init(snackbar) {
      var notification = document.querySelector('.mdl-js-snackbar');
      var data = {
        message: snackbar.message,
        actionHandler: snackbar.actionHandler,
        actionText: snackbar.actionText,
        timeout: 10000
      };
      notification.MaterialSnackbar.showSnackbar(data);
    }
  },
  mounted: function mounted() {
    this.$snackbar.init = this.init;
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    show: function show(message) {
      var notification = document.querySelector('.mdl-js-snackbar');
      notification.MaterialSnackbar.showSnackbar({ message: message });
    }
  },
  mounted: function mounted() {
    this.$toast.show = this.show;
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idb__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// require('./idb/index.js')
__webpack_require__(47);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(51).polyfill();







var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$loading = { show: function show() {} };
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$dialog = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toast = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$snackbar = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$actionbar = { init: function init() {}, destroy: function destroy() {} };
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$user = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$title = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$endpoint = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: isLocalhost ? 'http://localhost:8081/api' : 'https://appauditoria.gtglobal.com/api',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  validateStatus: function validateStatus(status) {
    return true;
    // return status >= 200 && status < 300
    //   || Vue.prototype.$toast.show('¡Algo sucedió! No se pudó conectar al servidor.')
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb = {
  'dbPromise': __WEBPACK_IMPORTED_MODULE_4_idb___default.a.open('gt-global', 1, function (upgradeDB) {
    switch (upgradeDB.oldVersion) {
      case 0:
        upgradeDB.createObjectStore('login', { keyPath: 'id' });

        var empresas = upgradeDB.createObjectStore('empresas', { keyPath: 'id' });
        empresas.createIndex('id', 'id');
        empresas.createIndex('padreId', 'padreId');

        var unidadesNegocio = upgradeDB.createObjectStore('unidades-negocio', { keyPath: 'id' });
        unidadesNegocio.createIndex('id', 'id');
        unidadesNegocio.createIndex('padreId', 'padreId');

        var inmuebles = upgradeDB.createObjectStore('inmuebles', { keyPath: 'id' });
        inmuebles.createIndex('id', 'id');
        inmuebles.createIndex('padreId', 'padreId');
        inmuebles.createIndex('activo', 'activo');

        upgradeDB.createObjectStore('areas', { keyPath: 'id' }).createIndex('padreId', 'padreId');
        upgradeDB.createObjectStore('rubros', { keyPath: 'id' }).createIndex('padreId', 'padreId');

        var tree = upgradeDB.createObjectStore('tree', { keyPath: 'id', autoIncrement: true });
        tree.createIndex('id', 'id');
    }
  }),
  'keyVal': {
    get: function get(ObjectStoreName, key) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        return db.transaction(ObjectStoreName).objectStore(ObjectStoreName).get(key);
      });
    },
    getOnly: function getOnly(ObjectStoreName, index, key) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        var values = [];
        return db.transaction(ObjectStoreName, 'readonly').objectStore(ObjectStoreName).index(index).openCursor(IDBKeyRange.only(key)).then(function log(cursor) {
          if (!cursor) return;
          // console.log("Cursored at:", cursor.value)
          values.push(cursor.value);
          return cursor.continue().then(log);
        }).then(function () {
          return values;
        });
      });
    },
    getAll: function getAll(ObjectStoreName) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        return db.transaction(ObjectStoreName).objectStore(ObjectStoreName).getAll();
      });
    },
    set: function set(ObjectStoreName, key, val) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        var tx = db.transaction(ObjectStoreName, 'readwrite');
        tx.objectStore(ObjectStoreName).put(val, key);
        return tx.complete;
      });
    },
    deleteOnly: function deleteOnly(ObjectStoreName, index, key) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        var deleted = 0;
        return db.transaction(ObjectStoreName, 'readwrite').objectStore(ObjectStoreName).index(index).openCursor(IDBKeyRange.only(key)).then(function log(cursor) {
          if (!cursor) return;
          return cursor.delete(cursor.primaryKey).then(function (event) {
            deleted += 1;
            return cursor.continue().then(log);
          }).catch(function (event) {
            return cursor.continue().then(log);
          });
        }).then(function () {
          return deleted;
        });
      });
    },
    delete: function _delete(ObjectStoreName, key) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        var tx = db.transaction(ObjectStoreName, 'readwrite');
        tx.objectStore(ObjectStoreName).delete(key);
        return tx.complete;
      });
    },
    clear: function clear(ObjectStoreName) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        var tx = db.transaction(ObjectStoreName, 'readwrite');
        tx.objectStore(ObjectStoreName).clear();
        return tx.complete;
      });
    },
    keys: function keys(ObjectStoreName) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$idb.dbPromise.then(function (db) {
        var tx = db.transaction(ObjectStoreName);
        var keys = [];
        var store = tx.objectStore(ObjectStoreName)

        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
        // openKeyCursor isn't supported by Safari, so we fall back
        (store.iterateKeyCursor || store.iterateCursor).call(store, function (cursor) {
          if (!cursor) return;
          keys.push(cursor.key);
          cursor.continue();
        });

        return tx.complete.then(function () {
          return keys;
        });
      });
    }
  }

  /* eslint-disable no-new */
};new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gt-aim.d78d081.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5718f324",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46de5281",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b2f55b4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60125c74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44db5568",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(254),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d86727d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(243),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8310fcf6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(224),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14af6420",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(257),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eadeafd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-754ecca8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-125805cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b86baaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(222),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c795662",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23d6e3e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(259),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f78f78e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(227),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18f1a0bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(256),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e30fb438",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abbf8d06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(242),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f1694f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8915ddc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ec6e0b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(251),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9a2d1dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ca854a9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15039f9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76b96c9b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8a3a4676",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8db9f992",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14d6fec9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(229),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a55e168",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce36a8d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(258),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f37cb4d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(255),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db76ddc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-96cfc822",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(252),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ca0b065a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-typography--text-center"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('refresh', true)
      }
    }
  }, [_vm._v("\n      Actualizar\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('h1', {
    staticClass: "mdl-typography--text-center"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dvr")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("\n      Aquí se mostrarán las auditorías que ocupen de una revisión"), _c('br'), _vm._v("\n      del contenido de sus INCIDENCIAS.\n    ")])])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--6-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("¡Bienvenido, "), _c('strong', [_vm._v(_vm._s(_vm.$user.data.givenName))]), _vm._v("!")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--2-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    staticClass: "mdl-typography--text-right",
    attrs: {
      "block": ""
    }
  }, [_vm._v(_vm._s(_vm.formatDate()))])])])
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-selectfield"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": "menu-input",
      "value": "Selecciona un filtro...",
      "type": "text",
      "readonly": "",
      "tabIndex": "-1"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('ul', {
    staticClass: "mdl-menu mdl-menu--bottom-left mdl-js-menu",
    attrs: {
      "for": "menu-input"
    },
    on: {
      "click": _vm.menuItemSelected
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item",
    attrs: {
      "data-filter": "por-status"
    }
  }, [_vm._v("Por Status")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "text-filter",
      "disabled": _vm.inputDisabled
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.search($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "text-filter"
    }
  }, [_vm._v("Texto a buscar...")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": _vm.inputDisabled
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])])
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout mdl-js-layout mdl-layout--fixed-header"
  }, [_c('app-header'), _vm._v(" "), _c('app-drawer'), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('app-action-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    staticClass: "mdl-dialog",
    attrs: {
      "id": "dialog"
    }
  }, [_c('h3', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v(_vm._s(_vm.dialog.title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [(_vm.dialog.isHTML) ? _c('div', {
    staticClass: "html",
    domProps: {
      "innerHTML": _vm._s(_vm.dialog.content)
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.dialog.content))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.accept()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cerrar")])])])
},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showReport) ? _c('div', {
    staticClass: "report"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("Da clic en alguna de las siguientes opciones para visualizar el "), _c('u', [_vm._v("reporte de auditoría")]), _vm._v(" al inmueble "), _c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))])]), _vm._v(" "), _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.downloadReport
    }
  }, [_vm._v("Descargar Reporte")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.showReportOnScreen
    }
  }, [_vm._v("Visualizar en Página")])]), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportLoaded),
      expression: "reportLoaded"
    }],
    attrs: {
      "id": "iframeid",
      "src": _vm.reportSrc,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.showReportOnScreenEnd
    }
  })], 1) : _c('div', {
    staticClass: "incidences"
  }, [_c('header', [_c('div', {
    staticClass: "card-cover mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__media",
    style: ({
      background: 'url(' + _vm.audit.cover + ') center / cover'
    })
  }), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.audit.promedio ? (_vm.audit.promedio >= _vm.audit.aceptable ? 'bg-green' : (_vm.audit.promedio > _vm.audit.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('div', {
    staticClass: "mdl-card__title_1"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.audit.empresa))])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__title_2"
  }, [_c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.incidencias))]), _vm._v(" "), _c('small', [_vm._v("Incidencias")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.promedio ? _vm.audit.promedio : 'N / A'))]), _vm._v(" "), _c('small', [_vm._v("Puntos")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('small', [_vm._v(_vm._s(_vm.audit.statusNombre.toUpperCase()))])])])]), _vm._v(" "), _vm._l((_vm.audit.mantenimiento), function(responsable) {
    return _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + responsable.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-grow-2"
    }, [_c('strong', [_vm._v(_vm._s(responsable.nombre))]), _vm._v(" "), _c('span', [_vm._v("Responsable de Mantenimiento")])]), _vm._v(" "), _c('div')])
  })], 2)]), _vm._v(" "), _c('main', [_vm._l((_vm.incidencias), function(incidencia, i) {
    return _c('div', {
      staticClass: "card-main mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_c('strong', [_vm._v(_vm._s(incidencia.area))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(incidencia.rubro))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__helper"
    }, [_c('small', [_vm._v(_vm._s(incidencia.especificacion.toUpperCase()))]), _vm._v(" "), _c('button', {
      class: ['current-chip', 'mdl-chip',
        'mdl-color--' + incidencia.color
      ],
      attrs: {
        "type": "button"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__media"
    }, _vm._l((incidencia.imagenes.split(',')), function(imagen, k) {
      return _c('div', {
        key: k,
        staticClass: "mdl-card mdl-shadow--2dp",
        style: ({
          background: 'url(' + incidencia.origen + imagen + ') center / cover'
        })
      }, [_c('div', {
        staticClass: "mdl-card__title mdl-card--expand"
      }), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__actions"
      }, [_c('span', {
        staticClass: "mdl-card__filename"
      }, [_vm._v("\n                " + _vm._s('Imagen #' + (k + 1) + ' de la incidencia.') + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu",
        staticStyle: {
          "left": "16px"
        }
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.downloadPicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_download")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "mdl-card__previus"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + '' + ')'
      })
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(incidencia.observaciones))])]), _vm._v(" "), (!incidencia.aprobada) ? _c('div', {
      staticClass: "revaluacion"
    }, [_c('label', {
      staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
      attrs: {
        "for": 'checkbox-' + i
      }
    }, [_c('input', {
      staticClass: "mdl-checkbox__input",
      attrs: {
        "type": "checkbox",
        "id": 'checkbox-' + i
      },
      on: {
        "change": function($event) {
          incidencia.revaluacion.aprobado = !$event.target.checked
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "mdl-checkbox__label"
    }, [_vm._v("Reevaluar Incidencia")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!incidencia.revaluacion.aprobado),
        expression: "!incidencia.revaluacion.aprobado"
      }],
      staticClass: "mdl-card__additional-text"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.$user.data.avatar || './img/profile-64.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.revaluacion.observaciones),
        expression: "incidencia.revaluacion.observaciones"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "rows": "3"
      },
      domProps: {
        "value": (incidencia.revaluacion.observaciones)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.revaluacion.observaciones = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label"
    }, [_vm._v("Escribe tus observaciones aquí...")])])])]) : _c('div', {
      staticClass: "bg-green-light",
      staticStyle: {
        "padding": "0.5rem"
      }
    }, [_c('p', {
      staticStyle: {
        "margin": "0"
      }
    }, [_vm._v("Esta incidencia ya fue aprobada.")])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incidencias.length === 0),
      expression: "incidencias.length === 0"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Todas las incidencias fueron calificadas en VERDE.")]), _vm._v(" "), _vm._m(0)])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Es necesario "), _c('strong', [_vm._v("Enviar la Evaluación")]), _vm._v(" para expresar su consentimiento.")])
}]}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-selectfield"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": "menu-input",
      "value": "Selecciona un filtro...",
      "type": "text",
      "readonly": "",
      "tabIndex": "-1"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('ul', {
    staticClass: "mdl-menu mdl-menu--bottom-left mdl-js-menu",
    attrs: {
      "for": "menu-input"
    },
    on: {
      "click": _vm.menuItemSelected
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item",
    attrs: {
      "data-filter": "por-auditor"
    }
  }, [_vm._v("Por Auditor")]), _vm._v(" "), _c('li', {
    staticClass: "mdl-menu__item",
    attrs: {
      "data-filter": "por-status"
    }
  }, [_vm._v("Por Status")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "text-filter",
      "disabled": _vm.inputDisabled
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.search($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "text-filter"
    }
  }, [_vm._v("Texto a buscar...")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": _vm.inputDisabled
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])])
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag),
      expression: "flag"
    }],
    staticClass: "mdl-card",
    attrs: {
      "centered": ""
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-card--expand"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active",
    attrs: {
      "centered": ""
    }
  })])
}]}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [_c(_vm.currentView, {
    tag: "component",
    on: {
      "viewChanged": function($event) {
        _vm.currentView = $event
      }
    }
  })], 1), _vm._v(" "), _c('app-dialog'), _vm._v(" "), _c('app-loading'), _vm._v(" "), _c('app-snackbar'), _vm._v(" "), _c('app-toast')], 1)
},staticRenderFns: []}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('header', {
    staticClass: "cover mdl-cell mdl-cell--8-col"
  }, [_c('div', {
    staticClass: "card-cover mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__media",
    style: ({
      background: 'url(' + _vm.tree.inmueble.imagen + ') center / cover'
    })
  }), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.promedio ? (_vm.promedio >= _vm.tree.inmueble.aceptable ? 'bg-green' : (_vm.promedio > _vm.tree.inmueble.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('div', {
    staticClass: "mdl-card__title_1"
  }, [_c('div', {
    staticClass: "mdl-card__title-media"
  }, [_c('img', {
    attrs: {
      "src": _vm.tree.unidadNegocio.imagen
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.tree.inmueble.nombre))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tree.empresa.nombre))])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__title_2"
  }, [_c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.tree.inmueble.incidencias))]), _vm._v(" "), _c('small', [_vm._v("Incidencias")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.promedio ? _vm.promedio : 'N / A'))]), _vm._v(" "), _c('small', [_vm._v("Puntos")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('small', [_vm._v(_vm._s(_vm.tree.inmueble.status || 'AUDITANDO'))])])])]), _vm._v(" "), _vm._l((_vm.tree.inmueble.mantenimiento), function(responsable) {
    return _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + responsable.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-grow-2"
    }, [_c('strong', [_vm._v(_vm._s(responsable.nombre))]), _vm._v(" "), _c('span', [_vm._v("Responsable de Mantenimiento")])]), _vm._v(" "), _c('div')])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('main', {
    staticClass: "events mdl-cell mdl-cell--8-col"
  }, _vm._l((_vm.data), function(d, i) {
    return _c('div', {
      key: i,
      staticClass: "card-event mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      class: ['mdl-card__title', 'mdl-card--expand',
        d.promedio ? (
          d.promedio >= d.aceptable ?
          'bg-green' :
          (d.promedio > d.inaceptable ?
            'bg-yellow' :
            'bg-red')
        ) : 'bg-grey'
      ]
    }, [_c('h4', [_vm._v("\n          " + _vm._s(d.promedio ? d.promedio : 'N / A')), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(d.nombre))]), _c('br'), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__actions mdl-card--border"
    }, [_c('a', {
      staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "data-i": i,
        "data-index": _vm.index,
        "data-value": d.id,
        "data-text": d.nombre,
        "data-father-id": d.padreId
      },
      on: {
        "click": _vm.clickEvent
      }
    }, [_vm._v("\n          Auditar\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-layout-spacer"
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('footer', {
    staticClass: "footer mdl-cell mdl-cell--8-col"
  }, [_c('div', {
    staticClass: "card-footer mdl-card mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tree.inmueble.resumen),
      expression: "tree.inmueble.resumen"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.tree.inmueble.resumen)
    },
    on: {
      "blur": _vm.guardarTree,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tree.inmueble.resumen = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label"
  }, [_vm._v("Escribe el resumen de la auditoría aquí...")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__menu"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h4', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Resumen de Auditoria")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    attrs: {
      "hidden": ""
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
  }, [_vm._v("\n          Get Started\n        ")])])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('header', {
    staticClass: "cover mdl-cell mdl-cell--8-col"
  }, [_c('div', {
    staticClass: "card-cover mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    class: ['mdl-card__title',
      _vm.promedio ? (
        _vm.promedio >= _vm.tree.area.aceptable ?
        'bg-green' :
        (_vm.promedio > _vm.tree.area.inaceptable ?
          'bg-yellow' :
          'bg-red')
      ) : 'bg-grey'
    ]
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("\n          " + _vm._s(_vm.promedio ? _vm.promedio : 'N / A')), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tree.area.nombre))]), _vm._v(" "), _c('p')])])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('main', {
    staticClass: "accordions mdl-cell mdl-cell--8-col"
  }, _vm._l((_vm.data), function(d, i) {
    return _c('mdl-accordion', {
      key: i,
      attrs: {
        "tree": _vm.tree,
        "data": d,
        "index": i
      },
      on: {
        "trigger": function($event) {
          _vm.calcularPromedio()
        }
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet mdl-typography--text-right"
  }, _vm._l((_vm.buttons), function(button) {
    return _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "disabled": button.disabled
      },
      on: {
        "click": button.onclick
      }
    }, [_vm._v("\n      " + _vm._s(button.text) + "\n    ")])
  }))])
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showReport) ? _c('div', {
    staticClass: "report"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("Da clic en alguna de las siguientes opciones para visualizar el "), _c('u', [_vm._v("reporte de auditoría")]), _vm._v(" al inmueble "), _c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))])]), _vm._v(" "), _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.downloadReport
    }
  }, [_vm._v("Descargar Reporte")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.showReportOnScreen
    }
  }, [_vm._v("Visualizar en Página")])]), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportLoaded),
      expression: "reportLoaded"
    }],
    attrs: {
      "id": "iframeid",
      "src": _vm.reportSrc,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.showReportOnScreenEnd
    }
  })], 1) : _c('div', {
    staticClass: "incidences"
  }, [_c('header', [_c('div', {
    staticClass: "card-cover mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__media",
    style: ({
      background: 'url(' + _vm.audit.cover + ') center / cover'
    })
  }), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.audit.promedio ? (_vm.audit.promedio >= _vm.audit.aceptable ? 'bg-green' : (_vm.audit.promedio > _vm.audit.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('div', {
    staticClass: "mdl-card__title_1"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.audit.empresa))])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__title_2"
  }, [_c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.incidencias))]), _vm._v(" "), _c('small', [_vm._v("Incidencias")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.promedio ? _vm.audit.promedio : 'N / A'))]), _vm._v(" "), _c('small', [_vm._v("Puntos")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('small', [_vm._v(_vm._s(_vm.audit.statusNombre.toUpperCase()))])])])]), _vm._v(" "), _vm._l((_vm.audit.mantenimiento), function(responsable) {
    return _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + responsable.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-grow-2"
    }, [_c('strong', [_vm._v(_vm._s(responsable.nombre))]), _vm._v(" "), _c('span', [_vm._v("Responsable de Mantenimiento")])]), _vm._v(" "), _c('div')])
  })], 2)]), _vm._v(" "), _c('main', [_vm._l((_vm.incidencias), function(incidencia, i) {
    return _c('div', {
      staticClass: "card-main mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_c('strong', [_vm._v(_vm._s(incidencia.area))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(incidencia.rubro))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__helper"
    }, [_c('small', [_vm._v(_vm._s(incidencia.especificacion.toUpperCase()))]), _vm._v(" "), _c('button', {
      class: ['current-chip', 'mdl-chip',
        'mdl-color--' + incidencia.color
      ],
      attrs: {
        "type": "button"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__media"
    }, _vm._l((incidencia.imagenes.split(',')), function(imagen, k) {
      return _c('div', {
        key: k,
        staticClass: "mdl-card mdl-shadow--2dp",
        style: ({
          background: 'url(' + incidencia.origen + imagen + ') center / cover'
        })
      }, [_c('div', {
        staticClass: "mdl-card__title mdl-card--expand"
      }), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__actions"
      }, [_c('span', {
        staticClass: "mdl-card__filename"
      }, [_vm._v("\n                " + _vm._s('Imagen #' + (k + 1) + ' de la incidencia.') + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu",
        staticStyle: {
          "left": "16px"
        }
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.downloadPicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_download")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "mdl-card__previus"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + '' + ')'
      })
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(incidencia.observaciones))])]), _vm._v(" "), _c('div', {
      staticClass: "plan-trabajo"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__additional-text"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.$user.data.avatar || './img/profile-64.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.planTrabajo.descripcion),
        expression: "incidencia.planTrabajo.descripcion"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "rows": "3",
        "disabled": _vm.audit.statusId !== 3
      },
      domProps: {
        "value": (incidencia.planTrabajo.descripcion)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.planTrabajo.descripcion = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label"
    }, [_vm._v("Escribe tus observaciones aquí...")])])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__additional-text",
      staticStyle: {
        "margin-left": "4rem"
      }
    }, [_c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
      staticStyle: {
        "margin-right": "1rem"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.planTrabajo.duracion),
        expression: "incidencia.planTrabajo.duracion"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "pattern": "-?[0-9]*(\\.[0-9]+)?",
        "id": 'duracion-' + i,
        "disabled": _vm.audit.statusId !== 3
      },
      domProps: {
        "value": (incidencia.planTrabajo.duracion)
      },
      on: {
        "keydown": _vm.onlyNumbers,
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.planTrabajo.duracion = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'duracion-' + i
      }
    }, [_vm._v("Duración (días)")]), _vm._v(" "), _c('span', {
      staticClass: "mdl-textfield__error"
    }, [_vm._v("Favor de escribir solo números.")])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.planTrabajo.costo),
        expression: "incidencia.planTrabajo.costo"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "pattern": "-?[0-9]*(\\.[0-9]+)?",
        "id": 'costo-' + i,
        "disabled": _vm.audit.statusId !== 3
      },
      domProps: {
        "value": (incidencia.planTrabajo.costo)
      },
      on: {
        "keydown": _vm.onlyNumbers,
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.planTrabajo.costo = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'duracion-' + i
      }
    }, [_vm._v("Costo estimado")]), _vm._v(" "), _c('span', {
      staticClass: "mdl-textfield__error"
    }, [_vm._v("Favor de escribir solo números.")])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incidencias.length === 0),
      expression: "incidencias.length === 0"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Todas las incidencias fueron calificadas en VERDE.")]), _vm._v(" "), _vm._m(1)])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Plan de Trabajo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Es necesario "), _c('strong', [_vm._v("Enviar el Plan de Trabajo")]), _vm._v(" para expresar su consentimiento.")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-accordion mdl-accordion--opened mdl-shadow--2dp"
  }, [_c('a', {
    staticClass: "mdl-accordion__button",
    on: {
      "click": _vm.toggleAccordion
    }
  }, [_c('i', {
    staticClass: "material-icons mdl-accordion__icon mdl-animation--default"
  }, [_vm._v("expand_more")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.data.nombre))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-accordion__content-wrapper"
  }, _vm._l((_vm.data.especificaciones), function(especificacion, i) {
    return _c('div', {
      key: especificacion.id,
      staticClass: "mdl-accordion__content mdl-animation--default",
      attrs: {
        "id": 'especificacion-' + especificacion.id
      }
    }, [_c('a', {
      staticClass: "mdl-accordion__link"
    }, [_c('span', {
      staticClass: "mdl-accordion__link-title"
    }, [_vm._v(_vm._s(especificacion.nombre))]), _vm._v(" "), _c('button', {
      class: ['current-chip', 'mdl-chip', 'mdl-color--' + especificacion.selected.color],
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.openChips
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-chip__buttons",
      attrs: {
        "data-i": i
      }
    }, _vm._l((especificacion.ponderaciones), function(ponderacion, j) {
      return _c('button', {
        key: ponderacion.id,
        class: ['mdl-chip', 'mdl-color--' + ponderacion.color],
        attrs: {
          "type": "button",
          "data-id": ponderacion.id,
          "data-color": ponderacion.color,
          "data-value": ponderacion.valor
        },
        on: {
          "click": _vm.chipSelected
        }
      })
    }))]), _vm._v(" "), _c('div', {
      class: ['incidence', 'mdl-grid',
        especificacion.selected.color.match(/red|yellow/) ?
        'incidence--opened' :
        ''
      ]
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (especificacion.imagenes.length === 0),
        expression: "especificacion.imagenes.length === 0"
      }],
      staticClass: "mdl-cell mdl-cell--12-col"
    }, [_vm._m(0, true), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (especificacion.imagenes.length > 0),
        expression: "especificacion.imagenes.length > 0"
      }],
      staticClass: "photos mdl-cell mdl-cell--12-col"
    }, _vm._l((especificacion.imagenes), function(imagen, k) {
      return _c('div', {
        key: k,
        staticClass: "mdl-card mdl-shadow--2dp",
        style: ({
          background: 'url(' + imagen + ') center / cover'
        })
      }, [_c('div', {
        staticClass: "mdl-card__title mdl-card--expand"
      }), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__actions"
      }, [_c('span', {
        staticClass: "mdl-card__filename"
      }, [_vm._v("\n                " + _vm._s('Imagen #' + (k + 1) + ' de la incidencia.') + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu",
        staticStyle: {
          "left": "16px"
        }
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.downloadPicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_download")])])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu"
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.removePicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("delete")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "mdl-cell mdl-cell--12-col mdl-typography--text-center"
    }, [_c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.uploadPicture
      }
    }, [_vm._v("\n            Agregar Fotografía(s)\n            "), _c('input', {
      staticClass: "hidden",
      attrs: {
        "type": "file",
        "accept": "image/*",
        "data-i": i
      },
      on: {
        "change": _vm.showPicture
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "comments mdl-cell mdl-cell--12-col"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.$user.data.avatar || './img/profile-64.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (especificacion.observaciones),
        expression: "especificacion.observaciones"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "rows": "3"
      },
      domProps: {
        "value": (especificacion.observaciones)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          especificacion.observaciones = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label"
    }, [_vm._v("Escribe tus observaciones aquí...")])])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "mdl-typography--text-center"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("photo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("\n            Puedes agregar hasta 3 imágenes como evidencia fotográfica"), _c('br'), _vm._v("\n            para justificar tu calificación.\n          ")])
}]}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), (_vm.showNewsfeed) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('welcome-message'), _vm._v(" "), _c('list-filter', {
    on: {
      "update": function($event) {
        _vm.updateNewsfeed($event)
      },
      "progress": function($event) {
        _vm.showProgress = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), (_vm.newsfeed.length === 0) ? [_c('empty-newsfeed', {
    on: {
      "refresh": function($event) {
        _vm.getNewsfeed()
      }
    }
  })] : _vm._l((_vm.newsfeed), function(data) {
    return _c('list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.showProgress),
        expression: "!showProgress"
      }],
      key: data.fecha,
      attrs: {
        "data": data
      },
      on: {
        "showReport": function($event) {
          _vm.showReport($event)
        }
      }
    })
  })], 2) : _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('audit-report', {
    attrs: {
      "audit": _vm.clickedAudit
    },
    on: {
      "showProgress": function($event) {
        _vm.showProgress2 = $event
      },
      "showNewsfeed": function($event) {
        _vm.showNewsfeed = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress2),
      expression: "showProgress2"
    }]
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--6-col-phone"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-selectfield"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": _vm.item.id,
      "readonly": "",
      "tabIndex": "-1"
    },
    domProps: {
      "value": _vm.item.selected.name || _vm.item.default.name
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('ul', {
    staticClass: "mdl-menu mdl-menu--bottom-left mdl-js-menu",
    attrs: {
      "for": _vm.item.id
    },
    on: {
      "click": _vm.menuItemSelected
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item",
    attrs: {
      "data-value": "-1",
      "data-index": _vm.index,
      "data-father-id": _vm.item.default.fatherId
    }
  }, [_vm._v(_vm._s(_vm.item.default.name))]), _vm._v(" "), _vm._l((_vm.item.data), function(data, i) {
    return _c('li', {
      key: data.id,
      staticClass: "mdl-menu__item",
      attrs: {
        "data-i": i,
        "data-index": _vm.index,
        "data-value": data.id,
        "data-father-id": data.padreId,
        "data-photo": data.imagen
      }
    }, [_vm._v(_vm._s(data.nombre))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), (_vm.showNewsfeed) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('welcome-message'), _vm._v(" "), _c('list-filter', {
    on: {
      "update": function($event) {
        _vm.updateNewsfeed($event)
      },
      "progress": function($event) {
        _vm.showProgress = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), (_vm.newsfeed.length === 0) ? [_c('empty-newsfeed', {
    on: {
      "refresh": function($event) {
        _vm.getNewsfeed()
      }
    }
  })] : _vm._l((_vm.newsfeed), function(data) {
    return _c('list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.showProgress),
        expression: "!showProgress"
      }],
      key: data.fecha,
      attrs: {
        "data": data
      },
      on: {
        "showReport": function($event) {
          _vm.showReport($event)
        }
      }
    })
  })], 2) : _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('audit-report', {
    attrs: {
      "audit": _vm.clickedAudit
    },
    on: {
      "showProgress": function($event) {
        _vm.showProgress2 = $event
      },
      "showNewsfeed": function($event) {
        _vm.showNewsfeed = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress2),
      expression: "showProgress2"
    }]
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showReport) ? _c('div', {
    staticClass: "report"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("Da clic en alguna de las siguientes opciones para visualizar el "), _c('u', [_vm._v("reporte de auditoría")]), _vm._v(" al inmueble "), _c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))])]), _vm._v(" "), _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.downloadReport
    }
  }, [_vm._v("Descargar Reporte")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.showReportOnScreen
    }
  }, [_vm._v("Visualizar en Página")])]), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportLoaded),
      expression: "reportLoaded"
    }],
    attrs: {
      "id": "iframeid",
      "src": _vm.reportSrc,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.showReportOnScreenEnd
    }
  })], 1) : _c('div', {
    staticClass: "incidences"
  }, [_c('header', [_c('div', {
    staticClass: "card-cover mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__media",
    style: ({
      background: 'url(' + _vm.audit.cover + ') center / cover'
    })
  }), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.audit.promedio ? (_vm.audit.promedio >= _vm.audit.aceptable ? 'bg-green' : (_vm.audit.promedio > _vm.audit.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.audit.empresa))])])]), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.audit.promedio ? (_vm.audit.promedio >= _vm.audit.aceptable ? 'bg-green' : (_vm.audit.promedio > _vm.audit.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.incidencias))]), _vm._v(" "), _c('small', [_vm._v("Incidencias")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.promedio ? _vm.audit.promedio : 'N / A'))]), _vm._v(" "), _c('small', [_vm._v("Puntos")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('small', [_vm._v(_vm._s(_vm.audit.statusNombre.toUpperCase()))])])]), _vm._v(" "), _vm._l((_vm.audit.mantenimiento), function(responsable) {
    return _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + responsable.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-grow-2"
    }, [_c('strong', [_vm._v(_vm._s(responsable.nombre))]), _vm._v(" "), _c('span', [_vm._v("Responsable de Mantenimiento")])]), _vm._v(" "), _c('div')])
  })], 2)]), _vm._v(" "), _c('main', _vm._l((_vm.incidencias), function(incidencia, i) {
    return _c('div', {
      staticClass: "card-main mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_c('strong', [_vm._v(_vm._s(incidencia.area))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(incidencia.rubro))])]), _vm._v(" "), _c('div', {
      staticClass: "chips mdl-card__helper"
    }, [_c('small', [_vm._v(_vm._s(incidencia.especificacion.toUpperCase()))]), _vm._v(" "), _c('button', {
      class: ['current-chip', 'mdl-chip', 'mdl-color--' + incidencia.color],
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.openChips
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-chip__buttons",
      attrs: {
        "data-i": i
      }
    }, _vm._l((incidencia.ponderaciones), function(ponderacion, j) {
      return _c('button', {
        key: ponderacion.id,
        class: ['mdl-chip', 'mdl-color--' + ponderacion.color],
        attrs: {
          "type": "button",
          "data-id": ponderacion.id,
          "data-color": ponderacion.color,
          "data-value": ponderacion.valor
        },
        on: {
          "click": _vm.chipSelected
        }
      })
    }))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (incidencia.color.match(/red|yellow/)),
        expression: "incidencia.color.match(/red|yellow/)"
      }],
      staticClass: "incidence mdl-grid"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (incidencia.update.imagenes.length === 0),
        expression: "incidencia.update.imagenes.length === 0"
      }],
      staticClass: "mdl-cell mdl-cell--12-col"
    }, [_vm._m(0, true)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (incidencia.update.imagenes.length > 0),
        expression: "incidencia.update.imagenes.length > 0"
      }],
      staticClass: "photos mdl-cell mdl-cell--12-col"
    }, _vm._l((incidencia.update.imagenes), function(imagen, k) {
      return _c('div', {
        key: k,
        staticClass: "mdl-card mdl-shadow--2dp",
        style: ({
          background: 'url(' + imagen + ') center / cover'
        })
      }, [_c('div', {
        staticClass: "mdl-card__title mdl-card--expand"
      }), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__actions"
      }, [_c('span', {
        staticClass: "mdl-card__filename"
      }, [_vm._v("\n                  " + _vm._s('Imagen #' + (k + 1) + ' de la incidencia.') + "\n                ")])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu",
        staticStyle: {
          "left": "16px"
        }
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.downloadPicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_download")])])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu"
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.removePicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("delete")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "mdl-cell mdl-cell--12-col mdl-typography--text-center"
    }, [_c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.uploadPhoto
      }
    }, [_vm._v("\n              Agregar Fotografía(s)\n              "), _c('input', {
      staticClass: "hidden",
      attrs: {
        "type": "file",
        "accept": "image/*",
        "data-i": i
      },
      on: {
        "change": _vm.showPicture
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
      attrs: {
        "type": "button",
        "data-i": i
      },
      on: {
        "click": _vm.showOldPictures
      }
    }, [_vm._v("\n              Ver imágenes anteriores\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + incidencia.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "supporting-text"
    }, [_c('strong', [_vm._v("Auditor")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incidencia.observaciones))])])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + incidencia.aprobacion.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "supporting-text"
    }, [_c('strong', [_vm._v("Jefe de Auditor")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incidencia.aprobacion.observaciones))])])]), _vm._v(" "), _c('div', {
      staticClass: "comments mdl-cell mdl-cell--12-col"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.$user.data.avatar || './img/profile-64.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.update.observaciones),
        expression: "incidencia.update.observaciones"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "rows": "3"
      },
      domProps: {
        "value": (incidencia.update.observaciones)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.update.observaciones = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label"
    }, [_vm._v("Escribe tus observaciones aquí...")])])])])])
  })), _vm._v(" "), _c('footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incidencias.length > 0),
      expression: "incidencias.length > 0"
    }],
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "card-footer mdl-card mdl-shadow--2dp"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumen),
      expression: "resumen"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.resumen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resumen = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label"
  }, [_vm._v("Escribe el resumen de la auditoría aquí...")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("\n              Puedes agregar hasta 3 imágenes como evidencia fotográfica"), _c('br'), _vm._v("\n              para justificar tu calificación.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h4', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Resumen de Auditoria")])])
}]}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__drawer mdl-color--grey-50 mdl-color-text--grey-800"
  }, [_c('header', {
    staticClass: "drawer-header bg-green"
  }, [_c('img', {
    staticClass: "drawer-avatar",
    attrs: {
      "src": _vm.$user.data.avatar || './profile-64.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-avatar-dropdown"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$user.data.email))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "drawer-navigation mdl-navigation mdl-color--grey-50 mdl-color-text--grey-800"
  }, [_vm._l((_vm.links), function(link) {
    return _c('router-link', {
      key: link.to,
      attrs: {
        "to": link.to
      }
    }, [_c('a', {
      staticClass: "mdl-navigation__link",
      on: {
        "click": _vm.toggleDrawer
      }
    }, [_c('i', {
      staticClass: "material-icons",
      attrs: {
        "role": "presentation"
      }
    }, [_vm._v(_vm._s(link.icon))]), _vm._v("\n        " + _vm._s(link.name) + "\n      ")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Cerrar Sesión")])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }, [_vm._v("\n    Cargando...\n  ")])])
}]}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-selectfield"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": "menu-input",
      "value": "Selecciona un filtro...",
      "type": "text",
      "readonly": "",
      "tabIndex": "-1"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('ul', {
    staticClass: "mdl-menu mdl-menu--bottom-left mdl-js-menu",
    attrs: {
      "for": "menu-input"
    },
    on: {
      "click": _vm.menuItemSelected
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item",
    attrs: {
      "data-filter": "por-status"
    }
  }, [_vm._v("Por Status")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "text-filter",
      "disabled": _vm.inputDisabled
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.search($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "text-filter"
    }
  }, [_vm._v("Texto a buscar...")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": _vm.inputDisabled
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])])
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-typography--text-center"
  }, [_c('router-link', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    attrs: {
      "to": "/auditoria"
    }
  }, [_vm._v("\n      Generar auditoría\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('refresh', true)
      }
    }
  }, [_vm._v("\n      Actualizar\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('h1', {
    staticClass: "mdl-typography--text-center"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dvr")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("\n      Aquí se mostrarán los reportes mas recientes que hayas realizado."), _c('br'), _vm._v("\n      Comienza un proceso de Auditoría en cualquiera de los inmuebles asignados para ti.\n    ")])])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mdl-list"
  }, [_c('li', {
    staticClass: "mdl-list__title"
  }, [_vm._v(_vm._s(_vm.data.fecha || '?'))]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.data.auditorias), function(auditoria, index) {
    return _c('li', {
      class: ['audit', 'mdl-list__item', 'mdl-list__item--two-line',
        auditoria.statusId === 4 ? 'bg-green-light' : ''
      ],
      attrs: {
        "data-index": index
      },
      on: {
        "click": _vm.showReport
      }
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('span', {
      staticClass: "mdl-list__item-title"
    }, [_vm._v(_vm._s(auditoria.inmueble))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-sub-title"
    }, [_vm._v(_vm._s(auditoria.empresa))])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      staticClass: "mdl-list__item-sub-title"
    }, [_vm._v(_vm._s(auditoria.incidencias))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-info"
    }, [_vm._v("Incidencias")])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      class: ['mdl-list__item-sub-title',
        auditoria.promedio >= auditoria.aceptable ? 'color-green-light' :
        (auditoria.promedio > auditoria.inaceptable ? 'color-yellow' : 'color-red')
      ]
    }, [_vm._v(_vm._s(auditoria.promedio))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-info"
    }, [_vm._v("Puntos")])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      class: ['mdl-list__item-secondary-info',
        auditoria.statusId === 4 ? 'color-green-light' :
        auditoria.statusId === 2 ? 'color-yellow' : ''
      ]
    }, [_vm._v(_vm._s(auditoria.statusNombre))])])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer')
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-50 mdl-color-text--grey-800 is-casting-shadow"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon",
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("refresh")])])])])
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-snackbar mdl-js-snackbar",
    attrs: {
      "aria-live": "assertive",
      "aria-atomic": "true",
      "aria-relevant": "text"
    }
  }, [_c('div', {
    staticClass: "mdl-snackbar__text"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-snackbar__action",
    attrs: {
      "type": "button"
    }
  })])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-typography--text-center"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('refresh', true)
      }
    }
  }, [_vm._v("\n      Actualizar\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('h1', {
    staticClass: "mdl-typography--text-center"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dvr")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("\n      Aquí se mostrarán las auditorías que contengan INCIDENCIAS las cuales necesitan"), _c('br'), _vm._v("\n      de un PLAN DE TRABAJO para su reparación.\n    ")])])
}]}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), (_vm.showNewsfeed) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('welcome-message'), _vm._v(" "), _c('list-filter', {
    on: {
      "update": function($event) {
        _vm.updateNewsfeed($event)
      },
      "progress": function($event) {
        _vm.showProgress = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), (_vm.newsfeed.length === 0) ? [_c('empty-newsfeed', {
    on: {
      "refresh": function($event) {
        _vm.getNewsfeed()
      }
    }
  })] : _vm._l((_vm.newsfeed), function(data) {
    return _c('list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.showProgress),
        expression: "!showProgress"
      }],
      key: data.fecha,
      attrs: {
        "data": data
      },
      on: {
        "showReport": function($event) {
          _vm.showReport($event)
        }
      }
    })
  })], 2) : _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('audit-report', {
    attrs: {
      "audit": _vm.clickedAudit
    },
    on: {
      "showProgress": function($event) {
        _vm.showProgress2 = $event
      },
      "showNewsfeed": function($event) {
        _vm.showNewsfeed = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress2),
      expression: "showProgress2"
    }]
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--6-col-phone",
    attrs: {
      "data-i": _vm.i,
      "data-index": _vm.index,
      "data-value": _vm.data.id,
      "data-text": _vm.data.nombre,
      "data-father-id": _vm.data.padreId,
      "data-photo": _vm.data.imagen
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [_c('div', {
    staticClass: "mdl-card__media mdl-color-text--grey-50",
    style: ('background-image:url(' + _vm.data.imagen + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text meta mdl-color-text--grey-600"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.data.nombre))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.hijosTotal + ' ' + _vm.data.hijosNombre))])])])])
},staticRenderFns: []}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--6-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("¡Bienvenido, "), _c('strong', [_vm._v(_vm._s(_vm.$user.data.givenName))]), _vm._v("!")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--2-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    staticClass: "mdl-typography--text-right",
    attrs: {
      "block": ""
    }
  }, [_vm._v(_vm._s(_vm.formatDate()))])])])
},staticRenderFns: []}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-snackbar mdl-js-snackbar",
    attrs: {
      "aria-live": "assertive",
      "aria-atomic": "true",
      "aria-relevant": "text"
    }
  }, [_c('div', {
    staticClass: "mdl-snackbar__text"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-snackbar__action",
    attrs: {
      "type": "button"
    }
  })])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout mdl-js-layout"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__content"
  }, [_c('button', {
    staticClass: "signin-button mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    attrs: {
      "id": "google-signin"
    }
  }, [_vm._v(_vm._s(_vm.signinText))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__media"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(185),
      "alt": "GT AIM Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h1', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("GT AIM")])])
}]}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid",
    attrs: {
      "id": "companies-index"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (item.types.includes('select')) ? _c('mdl-select', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "changeEvent": _vm.changed
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), _vm._l((_vm.items[_vm.currentIndex].data), function(data, i) {
    return (!_vm.showProgress && _vm.items[_vm.currentIndex].types.includes('card')) ? _c('mdl-card', {
      key: data.id,
      attrs: {
        "i": i,
        "data": data,
        "index": _vm.currentIndex,
        "clickEvent": _vm.changed
      },
      on: {
        "showActionbar": function($event) {
          _vm.actionbar = $event
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.showProgress && _vm.items[_vm.currentIndex].types.includes('summary')) ? _c('mdl-summary', {
    attrs: {
      "tree": _vm.tree,
      "data": _vm.items[_vm.currentIndex].data,
      "childData": _vm.items[_vm.currentIndex + 1].data,
      "index": _vm.currentIndex,
      "clickEvent": _vm.changed
    },
    on: {
      "activeAudit": function($event) {
        _vm.activeAudit = $event
      },
      "saveTree": function($event) {
        _vm.$idb.keyVal.set('tree', undefined, $event)
      },
      "goBack": function($event) {
        _vm.currentIndex += $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showProgress && _vm.items[_vm.currentIndex].types.includes('audit')) ? _c('mdl-audit', {
    attrs: {
      "tree": _vm.tree,
      "data": _vm.items[_vm.currentIndex].data,
      "index": _vm.currentIndex
    },
    on: {
      "activeAudit": function($event) {
        _vm.activeAudit = $event
      },
      "goBack": function($event) {
        _vm.currentIndex += $event
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet"
  }, [_vm._v("Mis Reportes 6 (8 tablet)")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--6-col-tablet"
  }, [_vm._v("Mis Reportes 4 (6 tablet)")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--4-col-phone"
  }, [_vm._v("Mis Reportes 2 (4 phone)")])])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--6-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("¡Bienvenido, "), _c('strong', [_vm._v(_vm._s(_vm.$user.data.givenName))]), _vm._v("!")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--2-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    staticClass: "mdl-typography--text-right",
    attrs: {
      "block": ""
    }
  }, [_vm._v(_vm._s(_vm.formatDate()))])])])
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mdl-list"
  }, [_c('li', {
    staticClass: "mdl-list__title"
  }, [_vm._v(_vm._s(_vm.data.fecha || '?'))]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.data.auditorias), function(auditoria, index) {
    return _c('li', {
      class: ['audit', 'mdl-list__item', 'mdl-list__item--two-line',
        auditoria.statusId >= 3 ? 'bg-green-light' : ''
      ],
      attrs: {
        "data-index": index
      },
      on: {
        "click": _vm.showReport
      }
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('span', {
      staticClass: "mdl-list__item-title"
    }, [_vm._v(_vm._s(auditoria.inmueble))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-sub-title"
    }, [_vm._v(_vm._s(auditoria.empresa))])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      staticClass: "mdl-list__item-sub-title"
    }, [_vm._v(_vm._s(auditoria.incidencias))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-info"
    }, [_vm._v("Incidencias")])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      class: ['mdl-list__item-sub-title',
        auditoria.promedio >= auditoria.aceptable ? 'color-green-light' :
        (auditoria.promedio > auditoria.inaceptable ? 'color-yellow' : 'color-red')
      ]
    }, [_vm._v(_vm._s(auditoria.promedio))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-info"
    }, [_vm._v("Puntos")])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      class: ['mdl-list__item-secondary-info',
        auditoria.statusId >= 3 ? 'color-green-light' :
        auditoria.statusId === 2 ? 'color-yellow' : ''
      ]
    }, [_vm._v(_vm._s(auditoria.statusNombre))])])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('div', {
    staticClass: "profile mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('header', {
    staticClass: "profile__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.$user.data.avatar,
      "alt": "Imagen de Perfil del Usuario"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "profile__header-title"
  }, [_vm._v(_vm._s(_vm.$user.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "profile__header-subtitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$user.data.email))])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('main', {
    staticClass: "profile__content"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('footer', {
    staticClass: "profile__footer"
  })])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mdl-list"
  }, [_c('li', {
    staticClass: "mdl-list__title"
  }, [_vm._v(_vm._s(_vm.data.fecha || '?'))]), _vm._v(" "), _c('li', _vm._l((_vm.data.auditores), function(auditor, index) {
    return _c('ul', {
      staticClass: "mdl-list",
      attrs: {
        "data-index": index
      }
    }, [_c('li', {
      staticClass: "mdl-list__item mdl-list__item--two-line",
      attrs: {
        "main-item": ""
      }
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('i', {
      staticClass: "material-icons mdl-list__item-avatar",
      style: ({
        backgroundImage: 'url(' + auditor.avatar + ')' || ''
      })
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(auditor.nombre))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-sub-title"
    }, [_vm._v(_vm._s(auditor.rol))])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      staticClass: "mdl-list__item-secondary-info"
    }, [_vm._v(_vm._s(auditor.auditorias.length) + " Auditorías")])])]), _vm._v(" "), _vm._l((auditor.auditorias), function(auditoria, index) {
      return _c('li', {
        class: ['audit', 'mdl-list__item', 'mdl-list__item--two-line',
          auditoria.statusId >= 3 ? 'bg-green-light' : ''
        ],
        attrs: {
          "data-index": index
        },
        on: {
          "click": _vm.showReport
        }
      }, [_c('span', {
        staticClass: "mdl-list__item-primary-content"
      }, [_c('span', {
        staticClass: "mdl-list__item-title"
      }, [_vm._v(_vm._s(auditoria.inmueble))]), _vm._v(" "), _c('span', {
        staticClass: "mdl-list__item-sub-title"
      }, [_vm._v(_vm._s(auditoria.empresa))])]), _vm._v(" "), _c('span', {
        staticClass: "mdl-list__item-secondary-content"
      }, [_c('span', {
        staticClass: "mdl-list__item-sub-title"
      }, [_vm._v(_vm._s(auditoria.incidencias))]), _vm._v(" "), _c('span', {
        staticClass: "mdl-list__item-secondary-info"
      }, [_vm._v("Incidencias")])]), _vm._v(" "), _c('span', {
        staticClass: "mdl-list__item-secondary-content"
      }, [_c('span', {
        class: ['mdl-list__item-sub-title',
          auditoria.promedio >= auditoria.aceptable ? 'color-green-light' :
          (auditoria.promedio > auditoria.inaceptable ? 'color-yellow' : 'color-red')
        ]
      }, [_vm._v(_vm._s(auditoria.promedio))]), _vm._v(" "), _c('span', {
        staticClass: "mdl-list__item-secondary-info"
      }, [_vm._v("Puntos")])]), _vm._v(" "), _c('span', {
        staticClass: "mdl-list__item-secondary-content"
      }, [_c('span', {
        class: ['mdl-list__item-secondary-info',
          auditoria.statusId >= 3 ? 'color-green-light' :
          auditoria.statusId === 2 ? 'color-yellow' : ''
        ]
      }, [_vm._v(_vm._s(auditoria.statusNombre))])])])
    })], 2)
  }))])
},staticRenderFns: []}

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[111]);


// WEBPACK FOOTER //
// static/js/app.27a428710e5cf0358ff4.js